const messages = {
  es: {
    errorMssgTracking:"No se han podido obtener datos \ndel estado del envío, probablemente porque la agencia no los proporciona por integración. \nPuede consultar el número de seguimiento en la web de la agencia.",
    codTracking: "Tracking",
    numTicket: "Ticket PDA",
    fechaOC: "Fecha OC",
    stockArticulos: "Stock de Artículos",
    ocPendientes: "Ordenes de Compra Pendientes",
    descOcPendientes: "Informe de Ordenes de Compra Pendientes de facturar",
    noRetenido: "No retenido",
    retenido: "Retenido",
    parcialmenteRetenido: "Parcialmente Retenido",
    dptoConcepto: "Departamento/Concepto",
    actCorrectamente: "Datos actualizados correctamente",
    centros: "Centros",
    centro: "Centro",
    familiaProv: "Cód. Familia",
    descFamiliaProv: "Desc Familia",
    idServicioWeb: "ID Servicio Portal",
    ordenCompra: "Orden Compra",
    fechaPrevista: "Fecha Prevista",
    cantidaPendiente: "Cantidad Pendiente",
    imagen: "Imagen",
    stockDisponible: "Stock Disponible",
    stockPotencial: "Stock Potencial",
    ubicacion: "Ubicación",
    lote: "Lote",
    cantidadExistente: "Cantidad Existente",
    ocMasReciente: "1º Fecha OC",
    diasSinCambiosEnEstado: "Días transcurridos desde la última fecha de cambio de estado del pedido.",
    diasAntiguedadDesc: "Días atrás que se hace para el primer filtrado de Pedidos/Albaranes.",
    activarFiltroDesc: "Ejecutar automáticamente la búsqueda de la consulta de pedidos.",
    documentos: "Documentos",
    pendiente: "Pendiente",
    datosPedido: "Datos del pedido",
    pedidoPendiente: "Pedido pendiente",
    codigoCliente: "Código cliente",
    datosGenerales: "Datos generales",
    descargas: "Descargas",
    validate: "Validar",
    deny: "Denegar",
    cancel: "Anular",
    pedidoPlanificado: "Pedido planificado",
    factura: "Factura",
    albaran: "Albarán",
    proforma: "Proforma",
    poblacionEnvio: "Población envío",
    poblacionFacturacion: "Población facturación",
    poblacion: "Población",
    poblacionAlm: "Población Alm.",
    correo: "Correo",
    direccion: "Dirección",
    direccionFacturacion: "Dirección de facturación",
    direccionEnvio: "Dirección de envío",
    datosFacturacion: "Datos facturación",
    facturacion: "Facturación",
    datosEnvio: "Datos envío",
    seleccionaUnArticulo: "Selecciona un artículo",
    lineasPedido: "Líneas pedido",
    fechaRecepcionPedido: "Fecha recepción pedido",
    numeroPedido: "Número pedido",
    tipoPedidoDesc: "Tipo pedido",
    descargarAlbaran: "Descargar albarán",
    descargarFactura: "Descargar factura",
    generarCompra: "Generar Compra",
    generandoOrdenCompra: "Generando Orden Compra",
    ocGenerada: "OC Generada",
    generarOC: "Generar OC",
    marcarTodos: "Marcar Todos",
    desmarcarTodos: "Desmarcar Todos",
    noLineasSeleccionadas: "No hay líneas seleccionadas",
    noLineasSeleccionadasDesc: "Debe seleccionar al menos una línea para generar la orden de compra.",
    ocGeneradaExito: "Orden de compra generada exitosamente",
    errorGenerarOC: "Error al generar orden de compra",
    errorProcesarSolicitud: "Error al procesar la solicitud",
    errorDesconocido: "Error desconocido",
    errorConexion: "Error de conexión",
    descProducto: "Desc Producto",
    seleccionaUnCliente: "Selecciona un cliente",
    seleccionaUnSucursal: "Selecciona una sucursal",
    selectRepresentante: "Selecciona un representante",
    selectProveedor: "Selecciona un proveedor",
    aplicarFiltrosYcomenzar: "Aplicar filtros y comenzar búsqueda",
    limpiarFiltros: "Limpiar filtros",
    OrderStatus: "Estado del pedido",
    Entered: "Entrados",
    Served: "Servidos",
    Invoiced: "Facturados",
    Detained: "Retenidos",
    Cancelled: "Cancelados",
    initial: "inicial",
    final: "final",
    nombreRepresentante: "Nombre representante",
    country: "País",
    Province: "Provincia",
    province: "provincia",
    cambioEstilo: "Cambio estilo",
    accessWithTokenDesc: "Accediendo a los informes",
    accesoAplicacion: "Acceso a la tienda web",
    gestionPresupuestos: "Portal para Clientes",
    areaClientes: "Area Clientes",
    usuario: "Usuario",
    contrasenya: "Contraseña",
    dominio: "Dominio",
    login: "LOGIN",
    iniciarSesion: "INICIAR SESIÓN",
    cerrarSesion: "Cerrar sesión",
    noAcceso: "Este usuario no tiene acceso permitido a la aplicación, consulte con su administrador",
    noConfigurado: "Este usuario no está configurado correctamente, consulte con el administrador",
    politicaPrivacidad1: "Sí, acepto la",
    politicaPrivacidad2: "Política de Privacidad",
    accesoInformes: "Acceso a Informes",
    errorLoginText: "El usuario no existe o la contraseña no es válida",
    presupuestosPedidos: "Presupuestos/Pedidos",
    entradaPedidos: "Entrada de Pedidos",
    listaPresupuestos: "Lista Presupuestos",
    buscarArt: "Buscar Artículo por Código o Denominación",
    buscar: "Buscar",
    registrosPagina: "registros por página",
    noResultados: "No existen registros para la búsqueda realizada",
    oResultados: "0 registros",
    acciones: "Acciones",
    aceptar: "Aceptar",
    cancelar: "Cancelar",
    limpiar: "Limpiar",
    cerrar: "Cerrar",
    campoRequerido: "Este campo es requerido",
    elementoCorrecto: "Debe seleccionar un elemento correcto",
    desconectar: "desconectar",
    deseaDesconectar: "¿Seguro que quiere desconectarse de la aplicación?",
    sesionCancelada: "Sesión cancelada. Vuelva a acceder a la aplicación.",
    noConexion: "No es posible acceder temporalemente al servicio. Si el problema persiste consulte con el Administrador",
    si: "Sí",
    no: "No",
    noSeleccion: "Debe seleccionar algún elemento",
    presupuestos: "Presupuestos",
    presupuestosDesc: "Informe de presupuestos",
    presupuesto: "Presupuesto",
    descripcion: "Descripción",
    informacion: "Información",
    pdfNotFound: "PDFs no encontrados",
    pdfNotFoundDesc: "Ha habido un problema a la hora de buscar los pdfs",
    zipNotFound: "Error con la descarga",
    zipNotFoundDesc: "Ha habido un problema con la descarga de los archivos.",
    responseFail: "Error en la conexión",
    responseFailDesc: "Ha habido un problema con la conexión al servidor.",
    usuarios: "Usuarios",
    administracionUsuarios: "Administración usuarios",
    listaUsuarios: "Lista de Usuarios",
    datosUsuario: "Datos usuario",
    tipoUsuario: "Tipo usuario",
    asociacionUsuarios: "Asociación Usuarios",
    accesosUsuario: "Accesos",
    nombre: "Nombre",
    email: "E-mail",
    telefono: "Teléfono",
    usuarioActivo: "Usuario activo",
    usuarioActualizado: "El usuario se ha actualizado correctamente",
    usuarioEliminado: "El usuario se ha eliminado correctamente",
    administrador: "Administrador",
    activacionUsuario: "Para activar un usuario debe completar la asociación del usuario",
    datos: "Datos",
    asociacion: "Asociación",
    totales: "Totales",
    fechas: "Fechas",
    tipoUser: "Tipo usuario",
    deleteItem: "Borrando...",
    saveDetPres: "Guardando Detalle presupuesto",
    saveCabPres: "Guardando Cabecera Presupuesto",
    iniCabPres: "Cargando presupuestos",
    iniCabArticulos: "Cargando articulos",
    iniImpresPres: "Cargando impreso",
    descargar: "Descargar",
    cargo: "Cargo",
    abono: "Abono",
    otros: "Otros",
    consultaPelikane: "Estado envío",
    comprasVentas: "Compras/Ventas",
    comprasVentasDesc: "Informe sobre las compras y ventas",
    clienteSeleccionado: "Cliente seleccionado:",
    dialogInfoCliente: "Información del cliente",
    dialogInfoPedido: "Información del pedido",
    cabeceraPedido: "Cabecera Pedido",
    consultaOrdenesFabricacion: "Órdenes de fabricación",
    estadoPedidosAlbaran: "Estado de Pedidos / Albaranes",
    estadoPedidosAlbaranDesc: "Informe del estado de los pedidos y albaranes",
    estadisticasVentas: "Ventas por Representante/cliente/mes",
    estadisticasVentasDesc: "Informe de ventas por Rep/cliente/mes",
    presupuestosInforme: "Informe sobre presupuestos",
    estadoVentas: "Estado de Ventas",
    estadoVentasDesc: "Informe para verificar el estado de las ventas",
    reimpresionFacturas: "Reimpresión de facturas",
    reimpresionFacturasDesc: "Informe para imprimir las facturas generadas",
    estadoVencimientos: "Estado del vencimiento de cobros",
    estadoVencimientosDesc: "Informe para ver el estado de los vencimientos",
    impagados: "Cobros pendientes vencidos y/o impagados",
    impagadosDesc: "Informe para verificar el estados de los pagos que aun no se han cobrado",
    guardadoDatosPendiente: "Tiene datos pendientes de guardar. ¿Desea guardarlos?",
    abrir: "Abrir",
    estadoPedidos: "Estado del Pedido",
    representanteInicialMayorFinal: "Número de representante inicial mayor que final",
    representanteVacio: "Se necesita un código de representante",
    clienteInicialMayorFinal: "Número de cliente inicial mayor que final",
    clienteVacio: "Se necesita un código de cliente",
    introducido: "Introducido",
    numeroFactura: "Número factura",
    accion: "Acción",
    descarga: "Descarga",
    fechaExpedicion: "F. Expedido",
    fechaInicial: "Fecha inicial",
    diasAntiguedad: "Dias de antiguedad",
    fechaInici: "Fecha inicio",
    fechaFinal: "Fecha final",
    fechaVencimiento: "Fecha de vencimiento",
    fechaInicialVencimiento: "Fecha vencimiento inicial",
    fechaFinalVencimiento: "Fecha vencimiento final",
    fechaInicialEntrega: "Fecha entrega inicial",
    fechaFinalEntrega: "Fecha entrega final",
    fechaFactura: "Fecha de factura",
    fechaInicialFactura: "Fecha factura inicial",
    fechaFinalFactura: "Fecha factura final",
    fechaInicialCliente: "Fecha cliente inicial",
    fechaFinalCliente: "Fecha cliente final",
    pedidos: "Pedidos",
    tipoVenta: "Tipo de venta",
    informes: "Informes",
    entrados: "Entrados",
    pendienteServir: "Pendiente Servir",
    pendienteFacturar: "Pendiente Facturar",
    facturados: "Facturados",
    cargaAbonos: "Cargos y Abonos",
    checkCargos: "Cargos",
    checkAbonos: "Abonos",
    todos: "Todos",
    activos: "Activos",
    pasivos: "Pasivos",
    inProcess: "En Proceso",
    cerrado: "Cerrado",
    cerrada: "Cerrada",
    contados: "Contados",
    creditos: "Créditos",
    articulo: "Artículo",
    obra: "Obra",
    articulosDesc: "Artículos",
    denominacion: "Denominación",
    denomLer: "Denom. LERS",
    descTrat: "Descripción tratamiento",
    codTrat: "Código de Tratamiento",
    codResiduo: "Código Residuo",
    nomResiduo: "Residuo",
    codServicio: "Código servicio",
    nomServicio: "Servicio",
    familiaArticulo: "Familia/Artículo",
    conceptoCliente: "Concepto(familia)/cliente",
    clienteConcepto: "Cliente/concept(familia)",
    clienteFamilia12m: "Cliente/familia(12 meses)",
    familiaCliente12m: "Familia/cliente(12 meses)",
    ventasXRepresentateCliMes: "VENTAS POR REP/CLIENTE/MES",
    nivel: "Nivel",
    tipoListado: "Tipo listado",
    listado: "Listado",
    enPreparacion: "En preparación",
    validando: "Validando",
    numeroFacturaCorto: "Nº Factura",
    numeroAlbaranCorto: "Nº Albarán",
    numCertificadoCorto: "Nº Certificado",
    operTraslado: "Traslado",
    fechaVig: "Fecha Fin Vigencia",
    fechaContr: "Fecha de Contrato",
    numContr: "Nº de Contrato",
    notfPrevia: "Notificación Previa",
    titularOrigen: "Origen",
    titularDestino: "Destino",
    fechaAlbaran: "Fecha Alb.",
    reviseFiltros: "Debe revisar el error detectado en los filtros antes de descargar el informe",
    reviseFiltrosBuscar: "Debe revisar el error detectado en los filtros antes de lanzar la busqueda",
    debeIndicarAlMenosUnoFiltro: "Debe indicar al menos uno de los siguientes campos: Fecha inicial, Código de representante o Número de pedido",
    noExisteElemento: "No existe elemento con ese código",
    clientes: "Clientes",
    nombrClienteRaz: "Nombre cliente / Razón Social",
    ClienteRaz: "Cliente / Razón Social",
    suReferencia: "S/Ref.",
    suReferenciaDesc: "Su referencia",
    dias: "Días",
    situacion: "Situación",
    agenciaTransporte: "Agencia Transporte",
    agente: "Agente",
    agenciaTte: "Agencia tte.",
    agenciaTransporteLink: "Link agencia de transporte",
    fechaCarga: "F. Prevista envío",
    fechaEntrega: "F. Entrega",
    fechaPrevExp: "F. Prev. Expedición",
    filtrarClientes: "Filtrar por clientes",
    riesgos: "Riesgos",
    riesgosDesc: "Cartera riesgos de cliente",
    fechaSituacion: "F. Situación",
    fechaPedido: "Fecha pedido",
    leyenda: "Leyenda",
    presupuestoLeyenda: "Presupuesto no confirmado",
    introducidoLeyenda: "Pedido introducido",
    pedidoEnviado: "Pedido enviado",
    pedidoConfirmado: "Pedido confirmado",
    pedidoEnPreparacion: "Pedido en preparación",
    pedidoRetenido: "Pedido retenido",
    enPreparacionLeyenda: "En preparación",
    planificadoLeyenda: "Planificada su fabricación",
    enFabricacionLeyenda: "Fabricación inciada",
    fabricadoLeyenda: "Fabricado",
    enFabricacion: "En fabricación",
    enviadoLeyenda: "Enviado",
    clientesSeleccionados: "clientes seleccionados",
    busquedaPorCliente: "Búsqueda por cliente",
    useAdvancedFilters: "Usar filtros avanzados",
    filterActions: "Acciones de filtros",
    busquedaPorRepresentante: "Búsqueda por representante",
    cif: "CIF",
    zonaDesc: "Seleccione una zona",
    provinciaDesc: "Seleccione una provincia",
    clienteSeleccionadoTabla: "Cliente a mostrar en tabla",
    seleccionarCliente: "Selección cliente",
    numRegPagina: "Número registros por página:",
    numPedidosPagina: "Número pedidos por página:",
    numCertifPagina: "Número de certificados por página",
    numRecogidas: "Número de recogidas por página",
    numEntradas: "Número de entradas por página",
    numPedidos: "Número de pedidos por página",
    numRecogidasEntradas: "Número de recogidas/entradas por página",
    factText: "Número de facturas por página",
    entregasRecogidasTransitos: "Estado de recogidas y entregas",
    contTratamientos: "Contratos Tratamientos",
    certificadoMedioAmbiental: "Certificados Medio Ambientales",
    numAlbaran: "Número Albarán",
    albaranTrans: "Albarán Tránsito",
    ticketPesada: "Ticket Pesada",
    numDI: "Número de DI",
    apoDI: "DI",
    advancedFilters: "Filtros avanzados",
    codCliente: "Código cliente",
    centroTrabajo: "Centro trabajo",
    codLER: "Código LER",
    tipoPedido: "Tipo",
    recogidasDesc: "Tabla de recogidas",
    entregasDesc: "Tabla de entregas",
    pedidosDesc: "Tabla de pedidos",
    transitosDesc: "Tabla de transacciones",
    recogidasBtn: "Recogidas",
    entregasBtn: "Entregas",
    pedidosBtn: "Pedidos",
    transitosBtn: "Todas",
    rolDesc: "Gestión de Roles",
    rolTable: "Roles",
    confAlmacenes: "Configurar Almacenes y Ubicaciones",
    tiposUsersText: "Tipos de usuario",
    albaranBtn: "Albarán",
    docIdBtn: "D.I.",
    ticketBtn: "Ticket",
    ticketImg: "Fotos Ticket",
    fotoBtn: "Fotografías",
    docAdj: "Documentos Adjuntos",
    todosBtn: "Todos",
    descargasDesc: "Descarga de los documentos correspondientes a la gestión",
    validateDesc: "Validar/Anular servicio",
    numCertificado: "Número Certificado",
    avisoTipoPedido: "T. Pedido no seleccionado",
    avisoTipoPedidoDesc: "Debe de seleccionar un tipo de pedido",
    mesFinal: "Mes final",
    mesInicial: "Mes inicial",
    mes: "Mes",
    codigoLER: "Código LER",
    destino: "Destino",
    tratamiento: "Tratamiento",
    uniMed: "UM",
    reciclaje: "% Reciclaje",
    checkValido: "Vencidos",
    factClte: "Albaranes de Clientes",
    factClteDesc: "Informe de albaranes pendientes de los clientes",
    factProv: "Facturas pendientes de proveedor",
    stockArticulo: "Consulta de Stock y Órdenes de Compra",
    descStockArticulo: "Informe de stock disponible, potencial y órdenes de compra",
    factProvDesc: "Informe de facturas pendientes de proveedor ",
    equery: "Equery",
    equeryDesc: "Programa Expert Query",
    albProv: "Albaranes de Proveedores",
    albProvDesc: "Informe de albaranes pendientes de los proveedores",
    contTratamientosDesc: "Informe de contratos de los tratamientos",
    facturasClientes: "Albaranes pendientes de facturar cliente",
    albaranesProv: "Albaranes pendientes de facturar proveedor",
    carrito: "carrito",
    tienda: "Tienda",
    familia: "Familia",
    familias: "Familias",
    subFamilias: "Subfamilias",
    arbol: "Árbol",
    categoria: "Categoría",
    categorias: "Categorías",
    productos: "Productos",
    productoos: "producto/s",
    paraBusqueda: "Para la busqueda",
    hay: "hay",
    caracteristicas: "Características",
    productosMismaFamilia: "Productos de la misma Familia",
    anadir: "Añadir",
    fichaProducto: "Ficha producto",
    todoCatalogo: "Todo el catálogo",
    categoriaActual: "Categoría actual",
    opcionesBusqueda: "Busqueda por defecto en:",
    filtros: "Filtros",
    catalogo: "Catálogo",
    irAlCarrito: "Ir al carrito",
    tramitarPedido: "Tramitar pedido",
    seguirComprando: "Seguir comprando",
    vaciarElCarrito: "Vaciar el carrito",
    existeCarrito: "Existe un carrito pendiente de tramitar, ¿Desea recuperarlo para finalizar la compra?",
    empiezaCompra: "Empieza a comprar",
    noHayProductosCarrito: "No hay productos en el carrito",
    totalProductos: "TOTAL PRODUCTOS:",
    total: "Total",
    borradoProducto: "¿Desea borrar el producto seleccionado?",
    borradoProductoCorto: "¿Desea borrar el producto?",
    vaciadoProducto: "¿Desea vaciar el carrito?",
    miCarrito: "Mi carrito:",
    productosEnTotal: "productos en total",
    pedido: "Pedido",
    pedidoWeb: "Pedido Web",
    tipoPed: "T. Pedido",
    nuevo: "Nuevo",
    borrar: "Borrar",
    filtrar: "Filtrar",
    observaciones: "Observaciones",
    observationDesc: "Escribe tus observaciones aquí...",
    numeroPresupuesto: "Número presupuesto",
    empresa: "Empresa",
    empresaFiscal: "Empresa Fiscal",
    cliente: "Cliente",
    otrosFiltros: "Otros Filtros",
    clienteInicial: "Cliente",
    clienteFinal: "Cliente final",
    sucursal: "Sucursal",
    codSucursal: "Código sucursal",
    seleccionaUnaSucursal: "Selecciona una sucursal",
    fechaCreacion: "Fecha Presupuesto",
    checkBorradoPresupuestos: "¿Seguro que quiere borrar el/los presupuesto/s?",
    checkBorradoLineaPresupuestos: "¿Seguro que quiere borrar la linea del presupuesto?",
    razonSocial: "Razón Social",
    editar: "Editar",
    imprimir: "Imprimir",
    excel: "Excel",
    resumenPresupuesto: "Resumen Presupuesto",
    activarFiltro: "Activar/Desactivar",
    continuar: "Guardar y continuar",
    saveAndExit: "Guardar y salir",
    volver: "Anterior",
    salir: "Salir",
    crear: "Crear",
    codigo: "Código",
    debeSeleccionar: "Debe seleccionar un elemento",
    debeSeleccionarFecha: "Debe seleccionar una fecha",
    asistentePresupuesto: "Asistente Presupuesto",
    asistenteNuevoPresupuesto: "Asistente Nuevo Presupuesto",
    procesando: "Procesando",
    empresaCliente: "Cliente y sucursal",
    seleccionEmpresaCliente: "Seleccione el cliente y la sucursal para el presupuesto",
    datosPresupuesto: "Cabecera Presupuesto",
    datosCabeceraPresupuesto: "Introduzca los datos de la cabecera del presupuesto",
    fecha: "Fecha",
    fechaAsignada: "F. pedido",
    fechaAceptacion: "Fecha Aceptación",
    plazoEntrega: "Plazo de entrega",
    Representante: "Representante",
    representante: "Representante",
    multisucursal: "Multi-Sucursal",
    representanteInicial: "Representante inicial",
    representanteFinal: "Representante final",
    formaPago: "Forma de pago",
    referencia: "Referencia",
    fechaVigencia: "Fecha Vigencia",
    descuento: "Descuento",
    descuentoPP: "Descuento PP",
    descuentoRappel: "Descuento Rappel",
    fechaVigenciaMayorFechaPedido: "La fecha de vigencia no puede ser menor que la fecha del presupuesto",
    plazoEntrgaMayorFechaPedido: "El plazo de entrega no puede ser menor que la fecha del presupuesto",
    articulos: "Detalle presupuesto",
    lineasPresupuesto: "Introduzca las líneas del presupuesto y sus comentarios",
    linea: "Línea",
    producto: "Producto",
    cantidad: "Cantidad",
    cantidadUMP: "Cantidad(UMP)",
    cantidadUMV: "Cantidad(UMV)",
    tarifa: "Tarifa",
    ume: "UME",
    precio: "Precio",
    dto: "Dto",
    brutoNeto: "Bruto / Neto",
    precioNeto: "Precio Neto",
    importe: "Importe",
    agrupaciones: "Agrupaciones",
    agrupacion: "Agrupación",
    orden: "Orden",
    nombreNuevaAgrupacion: "Nombre nueva Agrupación",
    checkBorradoAgrupaciones: "¿Seguro que quiere borrar la/s agrupación/es?",
    sinAgrupacion: "Sin Agrupación",
    sinBrutoNeto: "Sin Bruto / Neto",
    sinTarifa: "Sin Tarifa",
    sinDescuento: "Sin Descuento",
    guardar: "Guardar",
    bruto: "Bruto",
    neto: "Neto",
    buscador: "Buscador",
    buscadorProductos: "Buscador Productos",
    buscadorAvanzado: "Buscador Avanzado",
    volverAsistente: "Volver al asistente",
    busquedaArticulos: "Búsqueda de articulos",
    elementosSeleccionados: "Elementos seleccionados",
    noElementosSeleccionados: "no existe elementos seleccionados",
    resumen: "Resumen del Presupuesto",
    pantallaResumen: "Pantalla resumen con los datos del presupuesto elaborado",
    enviar: "Enviar",
    pasarPedido: "Pasar a Pedido",
    presupuestoPasadoPedido: "El Presupuesto se ha pasado a Pedido",
    filtroPresupuestos: "Filtrar Presupuestos",
    filtroClient: "Filtrar cliente",
    numPresu: "Número Presupuesto",
    numPresupIni: "Número Presupuesto Inicial",
    numPresupFin: "Número Presupuesto Final",
    fechaCreacionIni: "Fecha Inicial",
    fechaCreacionFin: "Fecha Final",
    fechaAceptacionIni: "Fecha Aceptación Inicial",
    fechaAceptacionFin: "Fecha Aceptación Final",
    mayorIgual: "mayor o igual que",
    menorIgual: "menor o igual que",
    y: "y",
    nombreEmpresa: "Nombre empresa",
    nombreCliente: "Nombre cliente",
    nombreProv: "Nombre proveedor",
    nombreSucursal: "Nombre sucursal",
    estados: "Estado/s",
    estado: "Estado",
    estadoEnvio: "Estado del envío",
    retenido: "Retenido",
    aceptado: "Aceptado",
    anulado: "Anulado",
    estadoFabricacion: "Estado fabricación",
    estadoPedido: "Estado pedido",
    fabricacion: "En fabricación",
    pedidosPendientes: "Pedidos pendientes",
    selectPresupuestos: "Presupuestos",
    selectEnFabricacion: "En fabricación",
    selectEnviados: "Enviados",
    servidos: "Pedidos enviados",
    pendientesPlanificar: "Pendientes de planificar",
    planificadaFabricacion: "Planificada fabricación",
    planificado: "Planificado",
    fabricado: "Fabricado",
    extraidaLista: "Extraida lista preparación",
    actualizadaLista: "Actualizada lista preparación",
    preparadoFacturacion: "Preparado facturación",
    actualizadoFacturacion: "Actualizado facturación",
    asignadoEtiquetas: "Asignado etiquetas",
    presupInicialMayorFinal: "Número de presupuesto inicial mayor que final",
    fechaInicialMayorFinal: "Fecha de inicial mayor que final",
    aplicar: "Aplicar",
    miCuenta: "Mi cuenta",
    mesEjercicioInicial: "Mes/Ejercicio Inicial",
    mesEjercicioFinal: "Mes/Ejercicio Final",
    mesEjercicioComparadoIni: "Mes/Ejercicio Comparado Inicial",
    mesEjercicioComparadoFin: "Mes/Ejercicio Comparado Final",
    estProvRepre: "ESTADÍSTICAS PROVINCIA/REPRESENTANTE",
    estProvRepreDesc: "Estadísticas por provincia y representante",
    EstadsProvRepre: "Estadísticas por provincia y representante",
    tipoRepresentante: "Tipo informe",
    ejercicio: "Ejercicio",
    recEntrTran: "Estado de recogidas y entregas",
    recEntrTranDesc: "Informe para verificar el estado de las recogidas y las entregas",
    certMed: "Certificado de Medio Ambiente",
    certMedDesc: "Certificado de Medio Ambiente",
    userFolder: "Consulta de cartera de clientes",
    userFolderDesc: "Informe para revis",
    incidencia: "Incidencia",
    diasDplazo: "Días de plazo",
    diasDplazoHasta: "Días de plazo hasta",
    nDarticulosArti: "N. Artículos/Artículos",
    nPedido: "N. Pedido",
    fPedido: "F. Pedido",
    fPedidoIniOFin: "F. Pedido inicial o final",
    fCompromisoIniOFin: "F. Compromiso inicial o final",
    fCompromisoEntrega: "F. Compromiso entrega",
    fPrevistaIniFabricacion: "F. Prevista Inicio Fab.",
    gFuncionalField: "G. Funcional/Servicio/Sección/Operación",
    gFuncional1: "Grupo funcional 1",
    gFuncional2: "Grupo funcional 2",
    gFuncional3: "Grupo funcional 3",
    gFuncional4: "Grupo funcional 4",
    fConfirmacion: "F. Confirmación",
    fPlanificacion: "F. Planificación",
    fAlbaran: "F. Albarán",
    soloConRetraso: "Sólo con retraso",
    ordenDeFabricacion: "Órden de fabricación",
    nDiasFabricacion: "Nº días fabricación",
    poweredDatadec: "Powered by DATADEC, S.A.",
    ordenesFabricacion: "Órdenes de fabricación",
    consultarOrdenesFabricacion: "Consultar órdenes de fabricación",
    consultaOrdenesFabricacionDesc: "Consultar órdenes de fabricación",
    cargandoContenido: "Cargando contenido",
    cargandoFechaDefecto: "Buscando contenido de los ",
    cargandoFechaDefectoAnterior: " días anteriores",
    nuevoUsuario: "Nuevo Usuario",
    anyadir: "Añadir",
    descargarProforma: "Descarga Proforma",
    facturaCsv: "D. FacturaCsv",
    cambiar: "Cambiar",
    cambioEmpresaTexto1: "Estás en la empresa: ",
    cambioEmpresaTexto2: ", para entrar necesitas estar en la ",
    cambioEmpresaTexto3: " ¿Deseas cambiar de empresa?",
    avisoFiltroCliente: "Filtrado por cliente asociado automático activado",
    avisoFiltroRepresentante: "Filtrado por representante asociado activado, usa el botón de buscar para ver resultados",
    avisoFiltroAdministrador: "Filtra por cliente, representante, o dos del resto de campos para obtener resultados",
    seleccion: "Seleccion",
    descargarSeleccion: "Descargar selección",
    errorCambioEmpresa: "Error al cambiar la empresa",
    errorComprobarEmpresa: "Error al comprobar la empresa",
    enero: "Enero",
    febrero: "Febrero",
    marzo: "Marzo",
    abril: "Abril",
    mayo: "Mayo",
    junio: "Junio",
    julio: "Julio",
    agosto: "Agosto",
    septiembre: "Septiembre",
    octubre: "Octubre",
    noviembre: "Noviembre",
    diciembre: "Diciembre",
    descargandoExcel: "Descargando Excel",
    descargandoContenido: "Esto puede tardar unos minutos, espere por favor",
    notValidDate: "¡Fechas no válidas!",
    notValidDateDesc: "¡Revise las fechas!",
    notFoundDefault: "¡No hay resultados!",
    notFoundDefaultDesc: "No se han encontrado resultados",
    notCentrosFoundDesc: "No se han encontrado centros asociados",
    errorCode: "Código pasado erróneo",
    requiredDate: "El campo es obligatorio!",
    urlNotFound: "¡No tiene archivo!",
    urlNotFoundDesc: "Este Certificado no contiene un archivo adjunto",
    avisoFactura: "¡Filtros necesarios!",
    avisoFacturaDesc: "Es necesario pasar un Representante o un Cliente.",
    notFoundReport: "¡No se ha encontado informe!",
    notFoundReportDesc: "No se ha encontrado el informe con los datos pasados",
    estadoVentaNotFound: "¡No se ha encontrado informe!",
    estadoVentaNotFoundDesc: "No se ha encontrado el informe con los datos pasados",
    vencimientoNotFound: "¡No se ha encontrado ningún informe!",
    vencimientoNotFoundDesc: "No se ha encontrado el informe con los datos pasados",
    vencimientoNotFoundError: "¡Error de conexión!",
    vencimientoNotFoundErrorDesc: "Error con la conexión, intentélo de nuevo o más tarde.",
    errorDefault: "¡Error de conexión!",
    errorDefaultDesc: "Error en la conexión del informe",
    errorNumRecogidas: "¡Error en la descarga!",
    errorNumRecogidasDesc: "No se puede descargar más de 1100 resultados",
    errorInsertUser: "¡Error al actualizar el usuario!",
    errorInsertUserDesc: "¡Comprueba que todo esté correcto!",
    errorInsertUser500: "No se ha podido actualizar el usuario correctamente",
    errorDeleteUser: "¡Error al eliminar el usuario!",
    insercionRoles: "¡Cambios realizados!",
    insercionRolesDesc: "Insertado correctamente las fechas",
    insercionRolesDescAct: "Actualizado correctamente las fechas",
    errorRoles: "¡Error encontrado!",
    errorRolesDesc: "Fallo a la hora de gestionar las fechas",
    notLoginDefault: "Error al loguear",
    notLoginDefaultDesc: "Fallo al intentar loguear",
    notFacturaFound: "No hay facturas",
    notFacturaFoundDesc: "No se han encontrado facturas",
    notAlbaranFound: "No hay albaran",
    notAlbaranFoundDesc: "No se han encontrado un informe de ese Albaran",
    notAlbaranFoundInPedDesc: "No hay ningún albarán asociado a ese pedido",
    notDataLoginFound: "Fallo al recuperar datos",
    notDataLoginFoundDesc: "No se ha podido recuperar los datos",
    onePresupuesto: "Debe de seleccionar un solo presupuesto",
    notStatusCorrect: "No puede editar un presupuesto que esté aceptado.",
    filtersAlert: "¡Filtros necesarios",
    filtersClientSuc: "Es necesario pasar un Cliente con su Sucursal.",
    filtersClient: "Es necesario pasar un Cliente.",
    filtersSuc: "Es necesario pasar una Sucursal.",
    delPres: "¡Error al eliminar presupuesto!",
    delPresDesc: "El presupuesto está aceptado y ya no se puede borrar.",
    tipoCompVen: "Tipo de pedido",
    noData: "No hay resultados",
    searchPanel: "Buscar",
    compras: "Compras",
    ventas: "Ventas",
    transitos: "Tránsitos",
    beneficio: "Beneficio",
    proveedor: "Proveedor",
    sucProveedor: "Sucursal Proveedor",
    matricula: "Matricula",
    precioMedio: "Precio Medio",
    transporte: "Transporte",
    almacen: "Almacen",
    albaranTte: "Albarán TTe",
    costeTte: "Coste TTE",
    importeTte: "Importe TTE",
    transportista: "Transportista",
    startsWidth: "Empieza con",
    equals: "Igual",
    between: "Entre",
    contains: "Contiene",
    endsWith: "Termina con",
    greaterThan: "Mayor que",
    lessThan: "Menor que",
    lessThanOrEqual: "Menor o igual que",
    notContains: "No contiene",
    notEqual: "Diferente",
    greaterThanOrEqual: "Mayor o igual que",
    reset: "Limpiar",
    filterMonth: "Filtrar por mes actual",
    filtroAvzClte: "Filtro avanzado de cliente",
    filtroAvzPed: "Filtro avanzado de pedido",
    descargaExcel: "Descarga Excel",
    alertsCancel: "Cancelar",
    alertsAceptar: "Aceptar",
    nuevaVersion: 'Se ha detectado una versión nueva. ¿Desea recargar la página?',
    selecBultoAlb: 'Seleccione un bulto del albarán',
    descagarExcel: 'Descargar Excel',
    consultaDocEstadoPed: "Consulta de documentos en el Estado de Pedidos",
    archivoEnviadoEmail: "El archivo sera enviado a {email}"
  },
  en: {
    codTracking: "Tracking",
    numTicket: "PDA Ticket",
    fechaOC: "PO Date",
    stockArticulos: "Stock of Articles",
    ocPendientes: "Pending Purchase Orders",
    descOcPendientes: "Report of Purchase Orders Pending Invoicing",
    noRetenido: "Not retained",
    retenido: "Retained",
    parcialmenteRetenido: "Partially retained",
    dptoConcepto: "Department/Concept",
    actCorrectamente: "Data updated successfully",
    centros: "Centers",
    centro: "Center",
    familiaProv: "Family Code",
    descFamiliaProv: "Family Desc",
    idServicioWeb: "Portal Service ID",
    ordenCompra: "Purchase Order",
    fechaPrevista: "Expected Date",
    cantidadPendiente: "Pending Quantity",
    imagen: "Image",
    stockDisponible: "Available Stock",
    stockPotencial: "Potential Stock",
    ubicacion: "Location",
    lote: "Batch",
    cantidadExistente: "Existing Quantity",
    ocMasReciente: "1st OC Date",
    diasSinCambiosEnEstado: "Days elapsed since the last order status change date.",
    diasAntiguedadDesc: "Days ago that is done for the first filtering of Orders/Albaranes.",
    activarFiltroDesc: "Automatically execute the order query search.",
    documentos: "Documents",
    pendiente: "Pending",
    datosPedido: "Order data",
    pedidoPendiente: "Backorder",
    codigoCliente: "Customer code",
    datosGenerales: "General data",
    descargas: "Downloads",
    validate: "Validate",
    deny: "Deny",
    cancel: "Cancel",
    pedidoPlanificado: "Planned order",
    factura: "Factura",
    albaran: "Delivery note",
    proforma: "Proforma",
    poblacionEnvio: "Shipping population",
    poblacionFacturacion: "Billing population",
    poblacion: "Population",
    poblacionAlm: "Alm.",
    correo: "Mail",
    direccion: "Address",
    direccionFacturacion: "Billing address",
    direccionEnvio: "Shipping address",
    datosFacturacion: "Billing data",
    facturacion: "Billing",
    datosEnvio: "Shipment data",
    seleccionaUnArticulo: "Select an item",
    lineasPedido: "Lines ordered",
    fechaRecepcionPedido: "Date order received",
    numeroPedido: "Order number",
    tipoPedidoDesc: "Order type",
    descargarAlbaran: "Download delivery note",
    descargarFactura: "Download invoice",
    generarCompra: "Generate Purchase",
    generandoOrdenCompra: "Generating Purchase Order",
    ocGenerada: "PO Generated",
    generarOC: "Generate PO",
    marcarTodos: "Select All",
    desmarcarTodos: "Unselect All",
    noLineasSeleccionadas: "No lines selected",
    noLineasSeleccionadasDesc: "You must select at least one line to generate the purchase order.",
    ocGeneradaExito: "Purchase order generated successfully",
    errorGenerarOC: "Error generating purchase order",
    errorProcesarSolicitud: "Error processing request",
    errorDesconocido: "Unknown error",
    errorConexion: "Connection error",
    descProducto: "Product Desc",
    seleccionaUnCliente: "Select a customer",
    seleccionaUnSucursal: "Select a branch",
    selectRepresentante: "Select a representative",
    selectProveedor: "Select a supplier",
    aplicarFiltrosYcomenzar: "Apply filters and start search",
    limpiarFiltros: "Clear filters",
    OrderStatus: "Order status",
    Entered: "Entered",
    Served: "Served",
    Invoiced: "Invoiced",
    Detained: "Retained",
    Cancelled: "Cancelled",
    initial: "initial",
    final: "final",
    nombreRepresentante: "Name of representative",
    country: "Country",
    Province: "Province",
    province: "province",
    cambioEstilo: "Style change",
    accessWithTokenDesc: "Accessing reports",
    accesoAplicacion: "Access to the web store",
    gestionPresupuestos: "Customer Portal",
    areaClientes: "Customer Area",
    usuario: "User",
    contrasenya: "Password",
    dominio: "Dominio",
    login: "LOGIN",
    iniciarSesion: "LOG IN",
    cerrarSesion: "Log off",
    noAcceso: "This user is not allowed access to the application, consult your administrator.",
    noConfigurado: "This user is not configured correctly, consult your administrator.",
    politicaPrivacidad1: "Yes, I accept the",
    politicaPrivacidad2: "Privacy Policy",
    accesoInformes: "Access to Reports",
    errorLoginText: "The user does not exist or the password is invalid.",
    presupuestosPedidos: "Quotations/Orders",
    entradaPedidos: "Order Entry",
    listaPresupuestos: "Budget List",
    buscar: "Search",
    buscarArt: "Search Article by Code or Name",
    registrosPagina: "records per page",
    noResultados: "there are no records for search performed",
    oResultados: "0 records",
    acciones: "Actions",
    aceptar: "Accept",
    cancelar: "Cancel",
    limpiar: "Clean",
    cerrar: "Close",
    campoRequerido: "This field is required",
    elementoCorrecto: "You must select a correct item",
    desconectar: "disconnect",
    deseaDesconectar: "Are you sure you want to disconnect from the application?",
    sesionCancelada: "Session terminated. Log back in to the application.",
    noConexion: "Temporary access to the service is not possible. If the problem persists, please contact the Administrator",
    si: "Yes",
    no: "No",
    noSeleccion: "You must select an item",
    presupuestos: "Budgets",
    presupuestosDesc: "Budget Report",
    presupuesto: "Budget",
    descripcion: "Description",
    informacion: "Information",
    pdfNotFound: "PDFs not found",
    pdfNotFoundDesc: "There has been a problem searching for pdfs.",
    zipNotFound: "Error with download",
    zipNotFoundDesc: "There has been a problem downloading the files.",
    responseFail: "Connection error",
    responseFailDesc: "There has been a problem with the server connection.",
    usuarios: "Users",
    administracionUsuarios: "User administration",
    listaUsuarios: "User List",
    datosUsuario: "User data",
    tipoUsuario: "User type",
    asociacionUsuarios: "Users Association",
    accesosUsuario: "Access",
    nombre: "Number",
    email: "Email",
    telefono: "Phone",
    usuarioActivo: "Active user",
    usuarioActualizado: "The user has been successfully updated",
    usuarioEliminado: "The user has been successfully deleted",
    administrador: "Administrator",
    activacionUsuario: "To activate a user you must complete the user's association",
    datos: "Data",
    asociacion: "Association",
    totales: "Totals",
    fechas: "Dates",
    tipoUser: "User type",
    deleteItem: "Smudging...",
    saveDetPres: "Saving Budget Detail",
    saveCabPres: "Saving Budget Header",
    iniCabPres: "Loading quotes",
    iniCabArticulos: "Cargando articulos",
    iniImpresPres: "Loading printouts",
    descargar: "Download",
    cargo: "Charge",
    abono: "Credit",
    otros: "Others",
    consultaPelikane: "Shipment status",
    comprasVentas: "Compras/Ventas",
    comprasVentasDesc: "Report on purchases and sales",
    clienteSeleccionado: "Selected customer:",
    dialogInfoCliente: "Customer information",
    dialogInfoPedido: "Order information",
    cabeceraPedido: "Cabecera Order",
    consultaOrdenesFabricacion: "Production orders",
    estadoPedidosAlbaran: "Order Status / Delivery Notes",
    estadoPedidosAlbaranDesc: "Order and delivery note status report",
    estadisticasVentas: "Sales per Representative/customer/month",
    estadisticasVentasDesc: "Sales report by Rep/customer/month",
    presupuestosInforme: "Budget Report",
    estadoVentas: "Sales Status",
    estadoVentasDesc: "Report to verify sales status",
    reimpresionFacturas: "Invoice reprinting",
    reimpresionFacturasDesc: "Report to print the generated invoices",
    estadoVencimientos: "Status of collection maturities",
    estadoVencimientosDesc: "Report to view the status of maturities",
    impagados: "Outstanding overdue and/or unpaid receivables",
    impagadosDesc: "Report to verify the status of payments that have not yet been collected",
    guardadoDatosPendiente: "You have data to save, do you want to save it?",
    abrir: "Open",
    estadoPedidos: "Order Status",
    representanteInicialMayorFinal: "Number of initial representative greater than final",
    representanteVacio: "A representative code is required",
    clienteInicialMayorFinal: "Initial number of customers greater than final number of customers",
    clienteVacio: "A customer code is required",
    introducido: "Entered",
    numeroFactura: "Invoice number",
    accion: "Action",
    descarga: "Download",
    fechaExpedicion: "F. Issued",
    fechaInicial: "Start date",
    diasAntiguedad: "Days of antiquity",
    fechaInici: "Start date",
    fechaFinal: "Final date",
    fechaVencimiento: "Expiration date",
    fechaInicialVencimiento: "Initial expiration date",
    fechaFinalVencimiento: "Final due date",
    fechaInicialEntrega: "Initial delivery date",
    fechaFinalEntrega: "Final delivery date",
    fechaFactura: "Invoice date",
    fechaInicialFactura: "Initial invoice date",
    fechaFinalFactura: "Final invoice date",
    fechaInicialCliente: "Initial customer date",
    fechaFinalCliente: "End customer date",
    pedidos: "Request",
    tipoVenta: "Type of sale",
    informes: "Reports",
    entrados: "Entered",
    pendienteServir: "Pending Serve",
    pendienteFacturar: "Pending Invoicing",
    facturados: "Invoiced",
    cargaAbonos: "Charges and Credits",
    checkCargos: "Charge orders",
    checkAbonos: "Credits",
    todos: "All",
    activos: "Active",
    pasivos: "Inactive",
    inProcess: "In Process",
    cerrado: "Closed",
    cerrada: "Cerrada",
    contados: "Counted",
    creditos: "Credits",
    articulo: "Article",
    obra: "Work",
    articulosDesc: "Articles",
    denominacion: "Designation",
    denomLer: "Denom. LERS",
    descTrat: "Treatment description",
    codTrat: "Treatment Code",
    codResiduo: "Waste Code",
    nomResiduo: "Waste",
    codServicio: "Service code",
    nomServicio: "Service",
    familiaArticulo: "Family/Article",
    conceptoCliente: "Concept(family)/client",
    clienteConcepto: "Customer/concept(family)",
    clienteFamilia12m: "Customer/family(12 months)",
    familiaCliente12m: "Family/client(12 months)",
    ventasXRepresentateCliMes: "SALES PER REP/CUSTOMER/MONTH",
    nivel: "Level",
    tipoListado: "Type listed",
    listado: "Listing",
    enPreparacion: "In preparation",
    validando: "Validating",
    numeroFacturaCorto: "Invoice No.",
    numeroAlbaranCorto: "Delivery note no.",
    numCertificadoCorto: "Certificate No.",
    operTraslado: "Transfer",
    fechaVig: "Effective End Date",
    fechaContr: "Contract Date",
    numContr: "Contract No.",
    notfPrevia: "Prior Notice",
    titularOrigen: "Origen",
    titularDestino: "Destination",
    fechaAlbaran: "Date Alb.",
    reviseFiltros: "You must check the error detected in the filters before downloading the report.",
    reviseFiltrosBuscar: "You must check the error detected in the filters before launching the search.",
    debeIndicarAlMenosUnoFiltro: "You must indicate at least one of the following fields: Initial date, Representative code or Order number",
    noExisteElemento: "There is no element with this code",
    clientes: "Customers",
    nombrClienteRaz: "Customer name / Company name",
    ClienteRaz: "Customer / Company Name",
    suReferencia: "S/Ref.",
    suReferenciaDesc: "Your reference",
    dias: "Days",
    situacion: "Situation",
    agenciaTransporte: "Transportation Agency",
    agente: "Agent",
    agenciaTte: "Agency Lt.",
    agenciaTransporteLink: "Transport agency link",
    fechaCarga: "F. Expected Shipment",
    fechaEntrega: "F. Delivery",
    fechaPrevExp: "Exp. Date of dispatch",
    filtrarClientes: "Filter by customer",
    riesgos: "Risks",
    riesgosDesc: "Customer risk portfolio",
    fechaSituacion: "F. Situation",
    fechaPedido: "Order date",
    leyenda: "Legend",
    presupuestoLeyenda: "Budget not confirmed",
    introducidoLeyenda: "Order entered",
    pedidoEnviado: "Order sent",
    pedidoConfirmado: "Order confirmed",
    pedidoEnPreparacion: "Order in preparation",
    pedidoRetenido: "Order held",
    enPreparacionLeyenda: "In preparation",
    planificadoLeyenda: "Planned production",
    enFabricacionLeyenda: "Incited manufacturing",
    fabricadoLeyenda: "Manufactured",
    enFabricacion: "In production",
    enviadoLeyenda: "Sent to",
    clientesSeleccionados: "selected customers",
    busquedaPorCliente: "Search by customer",
    useAdvancedFilters: "Using advanced filters",
    filterActions: "Filter actions",
    busquedaPorRepresentante: "Search by representative",
    cif: "CIF",
    zonaDesc: "Select a zone",
    provinciaDesc: "Select a province",
    clienteSeleccionadoTabla: "Customer to display in table",
    seleccionarCliente: "Customer selection",
    numRegPagina: "Number of records per page:",
    numPedidosPagina: "Number of orders per page:",
    numCertifPagina: "Number of certificates per page",
    numRecogidas: "Number of pickups per page",
    numEntradas: "Number of entries per page",
    numPedidos: "Number of orders per page",
    numRecogidasEntradas: "Number of pickups/entries per page",
    factText: "Number of invoices per page",
    entregasRecogidasTransitos: "Pickup and delivery status",
    contTratamientos: "Contracts Treatments",
    certificadoMedioAmbiental: "Environmental Certificates",
    numAlbaran: "Delivery Note Number",
    albaranTrans: "Transit Delivery Note",
    ticketPesada: "Ticket Pesada",
    numDI: "Number of DI",
    apoDI: "DI",
    advancedFilters: "Advanced filters",
    codCliente: "Customer code",
    centroTrabajo: "Work center",
    codLER: "LER Code",
    tipoPedido: "Type",
    recogidasDesc: "Collection table",
    entregasDesc: "Delivery table",
    pedidosDesc: "Ordering table",
    transitosDesc: "Transaction table",
    recogidasBtn: "Collections",
    entregasBtn: "Deliveries",
    pedidosBtn: "Request",
    transitosBtn: "All",
    rolDesc: "Role Management",
    rolTable: "Roles",
    tiposUsersText: "User types",
    confAlmacenes: "Configure Warehouses and Locations",
    albaranBtn: "Delivery note",
    docIdBtn: "D.I.",
    ticketBtn: "Ticket",
    ticketImg: "Photos Tickets",
    fotoBtn: "Photographs",
    docAdj: "Attached Documents",
    todosBtn: "All",
    descargasDesc: "Download the documents corresponding to the management",
    validateDesc: "Validate/Deny service",
    numCertificado: "Certificate Number",
    avisoTipoPedido: "T. Order not selected",
    avisoTipoPedidoDesc: "You must select an order type",
    mesFinal: "Final month",
    mesInicial: "Initial month",
    mes: "Mes",
    codigoLER: "LER Code",
    destino: "Destination",
    tratamiento: "Treatment",
    uniMed: "UM",
    reciclaje: "% Recycling",
    checkValido: "Overdue",
    factClte: "Customer Delivery Notes",
    factClteDesc: "Report of outstanding customer delivery notes",
    factProv: "Outstanding supplier invoices",
    stockArticulo: "Stock Inquiry and Purchase Orders",
    descStockArticulo: "Report on available stock, potential, and purchase orders",
    factProvDesc: "Outstanding supplier invoice report",
    equery: "Equery",
    equeryDesc: "Expert Query program",
    albProv: "Supplier delivery notes",
    albProvDesc: "Report of outstanding delivery notes from suppliers",
    contTratamientosDesc: "Treatment contract report",
    facturasClientes: "Delivery notes to be invoiced customer",
    albaranesProv: "Delivery notes to be invoiced supplier",
    carrito: "carrito",
    tienda: "Store",
    familia: "Family",
    familias: "Families",
    subFamilias: "Subfamilies",
    arbol: "Tree",
    categoria: "Category",
    categorias: "Categories",
    productos: "Products",
    productoos: "product/s",
    paraBusqueda: "For the search",
    hay: "hay",
    caracteristicas: "Features",
    productosMismaFamilia: "Products of the same family",
    anadir: "Add",
    fichaProducto: "Product sheet",
    todoCatalogo: "Entire catalog",
    categoriaActual: "Current category",
    opcionesBusqueda: "Default search in:",
    filtros: "Filtros",
    catalogo: "Catalog",
    irAlCarrito: "Go to cart",
    tramitarPedido: "Processing request",
    seguirComprando: "Continue shopping",
    vaciarElCarrito: "Emptying the cart",
    existeCarrito: "There is a pending cart, would you like to retrieve it to finalize the purchase?",
    empiezaCompra: "Start shopping",
    noHayProductosCarrito: "There are no products in the cart",
    totalProductos: "TOTAL PRODUCTS:",
    total: "Total",
    borradoProducto: "Do you want to delete the selected product?",
    borradoProductoCorto: "Do you want to delete the product?",
    vaciadoProducto: "Do you wish to empty the cart?",
    miCarrito: "Mi carrito:",
    productosEnTotal: "total products",
    pedido: "Order",
    pedidoWeb: "Order web",
    tipoPed: "Order type",
    nuevo: "New",
    borrar: "Drillers",
    filtrar: "Filtrar",
    observaciones: "Remarks",
    observationDesc: "Write some comment here...",
    numeroPresupuesto: "Budget number",
    empresa: "Company",
    empresaFiscal: "Fiscal Company",
    cliente: "Customer",
    otrosFiltros: "Other Filters",
    clienteInicial: "Customer",
    clienteFinal: "End customer",
    sucursal: "Branch",
    codSucursal: "Branch code",
    seleccionaUnaSucursal: "Select a branch",
    fechaCreacion: "Date Budget",
    checkBorradoPresupuestos: "Are you sure you want to delete the budget(s)?",
    checkBorradoLineaPresupuestos: "Are you sure you want to delete the budget line?",
    razonSocial: "Company name",
    editar: "Editar",
    imprimir: "Imprimir",
    excel: "Excel",
    resumenPresupuesto: "Budget Summary",
    activarFiltro: "Activate/Deactivate",
    continuar: "Save and continue",
    saveAndExit: "Save and exit",
    volver: "Previous",
    salir: "Salir",
    crear: "Crear",
    codigo: "Code",
    debeSeleccionar: "You must select an item",
    debeSeleccionarFecha: "You must select a date",
    asistentePresupuesto: "Budget Assistant",
    asistenteNuevoPresupuesto: "Assistant New Budget",
    procesando: "Processing",
    empresaCliente: "Customer and branch",
    seleccionEmpresaCliente: "Select customer and branch for quotation",
    datosPresupuesto: "Header Budget",
    datosCabeceraPresupuesto: "Enter the budget header data",
    fecha: "Date",
    fechaAsignada: "Order date",
    fechaAceptacion: "Acceptance Date",
    plazoEntrega: "Delivery time",
    Representante: "Representative",
    representante: "Representative",
    representanteInicial: "Initial representative",
    representanteFinal: "Final representative",
    formaPago: "Form of payment",
    referencia: "Reference",
    fechaVigencia: "Effective Date",
    descuento: "Discount",
    descuentoPP: "PP Discount",
    descuentoRappel: "Rappel Discount",
    fechaVigenciaMayorFechaPedido: "The effective date cannot be less than the budget date.",
    plazoEntrgaMayorFechaPedido: "The delivery time cannot be less than the date of the quotation.",
    articulos: "Budget detail",
    lineasPresupuesto: "Enter the budget lines and your comments",
    linea: "Line",
    producto: "Product",
    cantidad: "Quantity",
    cantidadUMP: "Quantity(UMP)",
    cantidadUMV: "Cantidad(UMV)",
    tarifa: "Tarifa",
    ume: "UME",
    precio: "Price",
    dto: "Dto",
    brutoNeto: "Gross / Grandson",
    precioNeto: "Precio Neto",
    importe: "Import",
    agrupaciones: "Groupings",
    agrupacion: "Grouping",
    orden: "Order",
    nombreNuevaAgrupacion: "New Grouping Name",
    checkBorradoAgrupaciones: "Are you sure you want to delete the grouping(s)?",
    sinAgrupacion: "No Grouping",
    sinBrutoNeto: "No Gross / Net",
    sinTarifa: "Sin Tarifa",
    sinDescuento: "No Discount",
    guardar: "Guardar",
    bruto: "Gross",
    neto: "Neto",
    buscador: "Searcher",
    buscadorProductos: "Product Finder",
    buscadorAvanzado: "Advanced search",
    volverAsistente: "Back to wizard",
    busquedaArticulos: "Search for articles",
    elementosSeleccionados: "Selected elements",
    noElementosSeleccionados: "there are no selected items",
    resumen: "Budget Summary",
    pantallaResumen: "Summary screen with the data of the prepared budget",
    enviar: "Send to",
    pasarPedido: "Pasar a Pedido",
    presupuestoPasadoPedido: "The Budget has been passed to Order",
    filtroPresupuestos: "Filter Budgets",
    filtroClient: "Filter customer",
    numPresu: "Number Budget",
    numPresupIni: "Number Initial Budget",
    numPresupFin: "Number Final Budget",
    fechaCreacionIni: "Initial Date",
    fechaCreacionFin: "Final Date",
    fechaAceptacionIni: "Date of Initial Acceptance",
    fechaAceptacionFin: "Final Acceptance Date",
    mayorIgual: "greater than or equal to",
    menorIgual: "less than or equal to",
    y: "y",
    nombreEmpresa: "Company name",
    nombreCliente: "Number of customers",
    nombreProv: "Supplier name",
    nombreSucursal: "Branch name",
    estados: "Status",
    estado: "Status",
    estadoEnvio: "Shipment status",
    retenido: "Retained",
    aceptado: "Accepted",
    anulado: "Canceled",
    estadoFabricacion: "Manufacturing status",
    estadoPedido: "Order status",
    fabricacion: "In production",
    pedidosPendientes: "Pending orders",
    selectPresupuestos: "Budgets",
    selectEnFabricacion: "In production",
    selectEnviados: "Sent to",
    servidos: "Orders submitted",
    pendientesPlanificar: "Pending planning",
    planificadaFabricacion: "Planned production",
    planificado: "Planned",
    fabricado: "Manufactured",
    extraidaLista: "Extracted preparation list",
    actualizadaLista: "Updated preparation list",
    preparadoFacturacion: "Prepared for invoicing",
    actualizadoFacturacion: "Updated invoicing",
    asignadoEtiquetas: "Assigned labels",
    presupInicialMayorFinal: "Number of initial budget greater than final",
    fechaInicialMayorFinal: "Start date greater than end date",
    aplicar: "Apply",
    miCuenta: "My account",
    mesEjercicioInicial: "Month/Year Initial",
    mesEjercicioFinal: "Month/Final Year",
    mesEjercicioComparadoIni: "Month/Year Compared Initial",
    mesEjercicioComparadoFin: "Month/Year Compared Final",
    estProvRepre: "STATISTICS PROVINCE/REPRESENTATIVE",
    estProvRepreDesc: "Statistics by province and representative",
    EstadsProvRepre: "Statistics by province and representative",
    tipoRepresentante: "Type report",
    ejercicio: "Exercise",
    recEntrTran: "Pickup and delivery status",
    recEntrTranDesc: "Report to verify the status of pickups and deliveries",
    certMed: "Environmental Certificate",
    certMedDesc: "Environmental Certificate",
    userFolder: "Customer portfolio inquiry",
    userFolderDesc: "Report for review",
    incidencia: "Incidence",
    diasDplazo: "Days of term",
    diasDplazoHasta: "Days to",
    nDarticulosArti: "N. Articles/Articles",
    nPedido: "N. Request",
    fPedido: "F. Request",
    fPedidoIniOFin: "F. Initial or final order",
    fCompromisoIniOFin: "F. Initial or final commitment",
    fCompromisoEntrega: "F. Commitment delivery",
    fPrevistaIniFabricacion: "F. Foreseen Start Fab.",
    gFuncionalField: "G. Functional/Service/Section/Operation",
    gFuncional1: "Functional group 1",
    gFuncional2: "Functional group 2",
    gFuncional3: "Functional group 3",
    gFuncional4: "Functional group 4",
    fConfirmacion: "F. Confirmation",
    fPlanificacion: "F. Planning",
    fAlbaran: "F. Albarán",
    soloConRetraso: "Only with delay",
    ordenDeFabricacion: "Production order",
    nDiasFabricacion: "No. days of production",
    poweredDatadec: "Powered by DATADEC, S.A.",
    ordenesFabricacion: "Production orders",
    consultarOrdenesFabricacion: "Consult production orders",
    consultaOrdenesFabricacionDesc: "Consult production orders",
    cargandoContenido: "Loading content",
    cargandoFechaDefecto: "Searching for content of the",
    cargandoFechaDefectoAnterior: " previous days",
    nuevoUsuario: "New User",
    anyadir: "Add",
    descargarProforma: "D. Proforma",
    facturaCsv: "D. FacturaCsv",
    cambiar: "Change",
    cambioEmpresaTexto1: "You are in the company:",
    cambioEmpresaTexto2: "to enter you need to be in the",
    cambioEmpresaTexto3: " Do you want to change company?",
    avisoFiltroCliente: "Filtering by associated customer automatically activated",
    avisoFiltroRepresentante: "Filtering by associated representative enabled, use the search button to view results",
    avisoFiltroAdministrador: "Filter by customer, representative, or two of the other fields to obtain results.",
    seleccion: "Selection",
    descargarSeleccion: "Download selection",
    errorCambioEmpresa: "Error when changing the company",
    errorComprobarEmpresa: "Error when checking the company",
    enero: "January",
    febrero: "February",
    marzo: "March",
    abril: "April",
    mayo: "Mayo",
    junio: "June",
    julio: "July",
    agosto: "August",
    septiembre: "September",
    octubre: "October",
    noviembre: "November",
    diciembre: "December",
    descargandoExcel: "Downloading Excel",
    descargandoContenido: "This may take a few minutes, please wait.",
    notValidDate: "Invalid dates!",
    notValidDateDesc: "Check the dates!",
    notFoundDefault: "No results!",
    notFoundDefaultDesc: "No results found",
    notCentrosFoundDesc: "No associated centers found",
    errorCode: "Erroneous past code",
    requiredDate: "The field is mandatory!",
    urlNotFound: "No file!",
    urlNotFoundDesc: "This Certificate does not contain an attachment",
    avisoFactura: "Filters required!",
    avisoFacturaDesc: "It is necessary to pass a Representative or a Client.",
    notFoundReport: "No report found!",
    notFoundReportDesc: "Report with past data not found",
    estadoVentaNotFound: "No report found!",
    estadoVentaNotFoundDesc: "Report with past data not found",
    vencimientoNotFound: "No report found!",
    vencimientoNotFoundDesc: "Report with past data not found",
    vencimientoNotFoundError: "Connection error!",
    vencimientoNotFoundErrorDesc: "Error with the connection, try again or later.",
    errorDefault: "Connection error!",
    errorDefaultDesc: "Error in report connection",
    errorNumRecogidas: "Download error!",
    errorNumRecogidasDesc: "Unable to download more than 1100 results",
    errorInsertUser: "Error updating the user!",
    errorInsertUserDesc: "Check that everything is correct!",
    errorInsertUser500: "The user could not be updated correctly",
    errorDeleteUser: "Error deleting user!",
    insercionRoles: "Changes made!",
    insercionRolesDesc: "Correctly inserted dates",
    insercionRolesDescAct: "Correctly updated dates",
    errorRoles: "Error found!",
    errorRolesDesc: "Failure to manage dates",
    notLoginDefault: "Error logging in",
    notLoginDefaultDesc: "Failed to login",
    notFacturaFound: "No invoices",
    notFacturaFoundDesc: "No invoices found",
    notAlbaranFound: "No packing slip",
    notAlbaranFoundDesc: "No report has been found for this Albaran",
    notAlbaranFoundInPedDesc: "There is no packing slip associated with this order.",
    notDataLoginFound: "Failure to recover data",
    notDataLoginFoundDesc: "Unable to recover data",
    onePresupuesto: "You must select only one budget",
    notStatusCorrect: "You cannot edit a budget that is accepted.",
    filtersAlert: "Filters required",
    filtersClientSuc: "It is necessary to pass a Customer with your Branch.",
    filtersClient: "It is necessary to pass a Customer.",
    filtersSuc: "It is necessary to pass a Branch.",
    delPres: "Error when deleting budget!",
    delPresDesc: "The quotation is accepted and can no longer be deleted.",
    tipoCompVen: "Order Type",
    noData: "No results found",
    searchPanel: "Search",
    compras: "Shopping",
    ventas: "Ventas",
    transitos: "Transits",
    beneficio: "Benefit",
    proveedor: "Supplier",
    sucProveedor: "Branch Supplier",
    matricula: "Registration",
    precioMedio: "Average Price",
    transporte: "Transportation",
    almacen: "Warehouse",
    albaranTte: "Albarán TTe",
    costeTte: "TTE coasts",
    importeTte: "Importe TTE",
    transportista: "Transportista",
    startsWidth: "Starts with",
    equals: "Same",
    between: "Enter",
    contains: "Contains",
    endsWith: "Ends with",
    greaterThan: "Greater than",
    lessThan: "Less than",
    lessThanOrEqual: "Less than or equal to",
    notContains: "Does not contain",
    notEqual: "Different",
    greaterThanOrEqual: "Greater than or equal to",
    reset: "Limpiar",
    filterMonth: "Filter by current month",
    filtroAvzClte: "Advanced Client Filter",
    filtroAvzPed: "Advanced Order Filter",
    descargaExcel: "Download Excel",
    alertsCancel: "Cancel",
    alertsAceptar: "Accept",
    nuevaVersion: 'A new version has been detected. Do you want to reload the page?',
    selecBultoAlb: 'Select a piece of packing slip',
    descagarExcel: 'Download Excel',
    consultaDocEstadoPed: "Consult documents in Order Status",
    archivoEnviadoEmail: "The file will be sent to {email}"
  },
  fr: {
    codTracking: "Tracking",
    numTicket: "Ticket PDA",
    fechaOC: "Date BC",
    stockArticulos: "Stock d'Articles",
    ocPendientes: "Commandes d'achat en attente",
    descOcPendientes: "Rapport des commandes d'achat en attente de facturation",
    noRetenido: "Non retenu",
    retenido: "Retenu",
    parcialmenteRetenido: "Partiellement retenu",
    dptoConcepto: "Département/Concept",
    actCorrectamente: "Données mises à jour correctement",
    centros: "Centres",
    centro: "Centre",
    familiaProv: "Code Famille",
    descFamiliaProv: "Desc Famille",
    idServicioWeb: "ID Service Portail",
    ordenCompra: "Bon de commande",
    fechaPrevista: "Date prévue",
    cantidadPendiente: "Quantité en attente",
    imagen: "Image",
    stockDisponible: "Stock Disponible",
    stockPotencial: "Stock Potentiel",
    ubicacion: "Emplacement",
    lote: "Lot",
    cantidadExistente: "Quantité Existante",
    ocMasReciente: "1ère Date BC",
    diasSinCambiosEnEstado: "Nombre de jours écoulés depuis la dernière date de modification du statut de l'ordre.",
    diasAntiguedadDesc: "Il y a quelques jours, cela a été fait pour le premier filtrage des Ordres/Albaranes.",
    activarFiltroDesc: "Exécuter automatiquement la recherche pour la requête de commande.",
    documentos: "Documents",
    pendiente: "En attente",
    datosPedido: "Détails de la commande",
    pedidoPendiente: "Commande en attente",
    codigoCliente: "Code client",
    datosGenerales: "Données générales",
    descargas: "Téléchargements",
    validate: "Valider",
    deny: "Déclin",
    cancel: "Annuler",
    pedidoPlanificado: "Demande prévue",
    factura: "Factura",
    albaran: "Bon de livraison",
    proforma: "Proforma",
    poblacionEnvio: "Envoi de population",
    poblacionFacturacion: "Roulement de la population",
    poblacion: "Population",
    poblacionAlm: "Alm.",
    correo: "Courriel",
    direccion: "Adresse",
    direccionFacturacion: "Adresse de facturation",
    direccionEnvio: "Adresse de livraison",
    datosFacturacion: "Données sur le chiffre d'affaires",
    facturacion: "Facturation",
    datosEnvio: "Données d'expédition",
    seleccionaUnArticulo: "Sélectionner un article",
    lineasPedido: "Lignes commandées",
    fechaRecepcionPedido: "Date de réception de la commande",
    numeroPedido: "Numéro de commande",
    tipoPedidoDesc: "Type de demande",
    descargarAlbaran: "Télécharger le bon de livraison",
    descargarFactura: "Télécharger la facture",
    generarCompra: "Générer un Achat",
    generandoOrdenCompra: "Génération du Bon de Commande",
    ocGenerada: "BC Généré",
    generarOC: "Générer BC",
    marcarTodos: "Tout Sélectionner",
    desmarcarTodos: "Tout Désélectionner",
    noLineasSeleccionadas: "Aucune ligne sélectionnée",
    noLineasSeleccionadasDesc: "Vous devez sélectionner au moins une ligne pour générer le bon de commande.",
    ocGeneradaExito: "Bon de commande généré avec succès",
    errorGenerarOC: "Erreur lors de la génération du bon de commande",
    errorProcesarSolicitud: "Erreur lors du traitement de la demande",
    errorDesconocido: "Erreur inconnue",
    errorConexion: "Erreur de connexion",
    descProducto: "Desc Produit",
    seleccionaUnCliente: "Sélectionner un client",
    seleccionaUnSucursal: "Sélectionner une branche",
    selectRepresentante: "Sélectionner un représentant",
    selectProveedor: "Sélectionner un fournisseur",
    aplicarFiltrosYcomenzar: "Appliquer des filtres et lancer la recherche",
    limpiarFiltros: "Éliminer filtres",
    OrderStatus: "Statut de la commande",
    Entered: "Entré",
    Served: "Servi",
    Invoiced: "Facturé",
    Detained: "Conservé",
    Cancelled: "Annulé",
    initial: "initial",
    final: "final",
    nombreRepresentante: "Nom du représentant",
    country: "Pays",
    Province: "Province",
    province: "province",
    cambioEstilo: "Changement de style",
    accessWithTokenDesc: "Accès aux rapports",
    accesoAplicacion: "Accès à la boutique en ligne",
    gestionPresupuestos: "Portail clients",
    areaClientes: "Espace client",
    usuario: "Utilisateur",
    contrasenya: "Mot de passe",
    dominio: "Dominio",
    login: "LOGIN",
    iniciarSesion: "LOG IN",
    cerrarSesion: "Déconnexion",
    noAcceso: "Cet utilisateur n'a pas accès à l'application, consultez votre administrateur.",
    noConfigurado: "Cet utilisateur n'est pas configuré correctement, veuillez vérifier avec votre administrateur.",
    politicaPrivacidad1: "Oui, j'accepte la",
    politicaPrivacidad2: "Politique de confidentialité",
    accesoInformes: "Accès aux rapports",
    errorLoginText: "L'utilisateur n'existe pas ou le mot de passe n'est pas valide.",
    presupuestosPedidos: "Budgets/commandes",
    entradaPedidos: "Saisie des commandes",
    listaPresupuestos: "Liste du budget",
    buscar: "Recherche",
    buscarArt: "Rechercher un article par code ou désignation",
    registrosPagina: "enregistrements par page",
    noResultados: "aucun enregistrement pour la recherche effectuée",
    oResultados: "0 enregistrements",
    acciones: "Actions",
    aceptar: "Accepter",
    cancelar: "Annuler",
    limpiar: "Limpiar",
    cerrar: "Cerrar",
    campoRequerido: "Ce champ est obligatoire",
    elementoCorrecto: "Vous devez sélectionner un élément correct",
    desconectar: "se déconnecter",
    deseaDesconectar: "Êtes-vous sûr de vouloir vous déconnecter de l'application ?",
    sesionCancelada: "Session terminée. Se reconnecter à l'application.",
    noConexion: "L'accès temporaire au service n'est pas possible. Si le problème persiste, veuillez contacter l'administrateur.",
    si: "Sí",
    no: "Non",
    noSeleccion: "Vous devez sélectionner un élément",
    presupuestos: "Budgets",
    presupuestosDesc: "Rapport sur le budget",
    presupuesto: "Budget",
    descripcion: "Description",
    informacion: "Informations",
    pdfNotFound: "PDF introuvables",
    pdfNotFoundDesc: "Il y a eu un problème dans la recherche des pdf.",
    zipNotFound: "Erreur de téléchargement",
    zipNotFoundDesc: "Il y a eu un problème de téléchargement des fichiers.",
    responseFail: "Erreur de connexion",
    responseFailDesc: "Il y a eu un problème de connexion au serveur.",
    usuarios: "Utilisateurs",
    administracionUsuarios: "Administration des utilisateurs",
    listaUsuarios: "Liste des utilisateurs",
    datosUsuario: "Données de l'utilisateur",
    tipoUsuario: "Type d'utilisateur",
    asociacionUsuarios: "Association des utilisateurs",
    accesosUsuario: "Accès",
    nombre: "Nombre",
    email: "Courriel",
    telefono: "Téléphone",
    usuarioActivo: "Utilisateur actif",
    usuarioActualizado: "L'utilisateur a été mis à jour avec succès",
    usuarioEliminado: "L'utilisateur a été supprimé avec succès",
    administrador: "Administrateur",
    activacionUsuario: "Pour activer un utilisateur, vous devez compléter l'association de l'utilisateur",
    datos: "Données",
    asociacion: "Association",
    totales: "Total",
    fechas: "Dates",
    tipoUser: "Type d'utilisateur",
    deleteItem: "Salir...",
    saveDetPres: "Détail du budget d'épargne",
    saveCabPres: "En-tête du budget d'épargne",
    iniCabPres: "Chargement des budgets",
    iniCabArticulos: "Accumulation d'articles",
    iniImpresPres: "Chargement des impressions",
    descargar: "Télécharger",
    cargo: "Cargo",
    abono: "Avoir",
    otros: "Autres",
    consultaPelikane: "Statut de l'envoi",
    comprasVentas: "Compras/Ventas",
    comprasVentasDesc: "Rapport sur les achats et les ventes",
    clienteSeleccionado: "Client sélectionné :",
    dialogInfoCliente: "Informations sur les clients",
    dialogInfoPedido: "Informations sur les commandes",
    cabeceraPedido: "Demande de Cabecera",
    consultaOrdenesFabricacion: "Ordres de fabrication",
    estadoPedidosAlbaran: "État de commandes/Bons livraisons ",
    estadoPedidosAlbaranDesc: "Rapport sur l'état des commandes et des bons de livraison",
    estadisticasVentas: "Ventes par représentant/client/mois",
    estadisticasVentasDesc: "Rapport de ventes par représentant/client/mois",
    presupuestosInforme: "Rapport sur les budgets",
    estadoVentas: "État des ventes",
    estadoVentasDesc: "Rapport pour vérifier l'état des ventes",
    reimpresionFacturas: "Réimpression des factures",
    reimpresionFacturasDesc: "Rapport pour imprimer les factures générées",
    estadoVencimientos: "État des échéances des créances",
    estadoVencimientosDesc: "Rapport permettant de visualiser l'état des échéances",
    impagados: "Créances en souffrance et/ou impayées",
    impagadosDesc: "Rapport permettant de vérifier le statut des paiements qui n'ont pas encore été perçus.",
    guardadoDatosPendiente: "Vous avez des données à sauvegarder, voulez-vous les sauvegarder ?",
    abrir: "Ouvrir",
    estadoPedidos: "Statut de la commande",
    representanteInicialMayorFinal: "Nombre représentatif initial supérieur au nombre final",
    representanteVacio: "Un code représentatif est requis",
    clienteInicialMayorFinal: "Nombre de clients initiaux supérieur au nombre de clients finaux",
    clienteVacio: "Un code client est nécessaire",
    introducido: "Introduit",
    numeroFactura: "Numéro de facture",
    accion: "Action",
    descarga: "Télécharger",
    fechaExpedicion: "F. Délivré",
    fechaInicial: "Date de début",
    diasAntiguedad: "Jours de l'antiquité",
    fechaInici: "Date de début",
    fechaFinal: "Date limite",
    fechaVencimiento: "Date d'expiration",
    fechaInicialVencimiento: "Date d'expiration initiale",
    fechaFinalVencimiento: "Date d'expiration finale",
    fechaInicialEntrega: "Date de livraison initiale",
    fechaFinalEntrega: "Date de livraison finale",
    fechaFactura: "Date de la facture",
    fechaInicialFactura: "Date de la facture initiale",
    fechaFinalFactura: "Date de la facture finale",
    fechaInicialCliente: "Date initiale du client",
    fechaFinalCliente: "Date du client final",
    pedidos: "Demandes",
    tipoVenta: "Type de vente",
    informes: "Rapports",
    entrados: "Entré",
    pendienteServir: "En attente de service",
    pendienteFacturar: "Facturation en cours",
    facturados: "Facturé",
    cargaAbonos: "Charges et crédits",
    checkCargos: "Factures",
    checkAbonos: "Avoirs",
    todos: "Tous",
    activos: "Actifs",
    pasivos: "Inactifs",
    inProcess: "En cours",
    cerrado: "Fermé",
    cerrada: "Cerrada",
    contados: "Comptabilisé",
    creditos: "Créditos",
    articulo: "Article",
    obra: "Travaux",
    articulosDesc: "Articles",
    denominacion: "Désignation",
    denomLer: "Dénom. LERS",
    descTrat: "",
    codTrat: "Code de traitement",
    codResiduo: "Code des déchets",
    nomResiduo: "Déchets",
    codServicio: "Code de service",
    nomServicio: "Service",
    familiaArticulo: "Famille/Article",
    conceptoCliente: "Concept(famille)/client",
    clienteConcepto: "Client/concept(famille)",
    clienteFamilia12m: "Client/famille (12 mois)",
    familiaCliente12m: "Famille/client (12 mois)",
    ventasXRepresentateCliMes: "VENTES PAR REPRÉSENTANT/CLIENT/MOIS",
    nivel: "Niveau",
    tipoListado: "Type répertorié",
    listado: "Liste",
    enPreparacion: "En préparation",
    validando: "Valider",
    numeroFacturaCorto: "Numéro de facture",
    numeroAlbaranCorto: "Bon de livraison n°.",
    numCertificadoCorto: "Numéro de certificat",
    operTraslado: "Déménagement",
    fechaVig: "Date de fin effective",
    fechaContr: "Date du contrat",
    numContr: "N° de contrat",
    notfPrevia: "Notification préalable",
    titularOrigen: "Origen",
    titularDestino: "Destination",
    fechaAlbaran: "Date Alb.",
    reviseFiltros: "Vous devez vérifier l'erreur détectée dans les filtres avant de télécharger le rapport.",
    reviseFiltrosBuscar: "Vous devez vérifier l'erreur détectée dans les filtres avant de lancer la recherche.",
    debeIndicarAlMenosUnoFiltro: "Vous devez indiquer au moins l'un des champs suivants : Date initiale, Code du représentant ou Numéro de commande",
    noExisteElemento: "Il n'y a pas d'élément avec ce code",
    clientes: "Clients",
    nombrClienteRaz: "Nom du client / Nom de l'entreprise",
    ClienteRaz: "Nom du client / de l'entreprise",
    suReferencia: "S/Ref.",
    suReferenciaDesc: "Votre référence",
    dias: "Jours",
    situacion: "Situation",
    agenciaTransporte: "Agence des transports",
    agente: "Agent",
    agenciaTte: "Agence Lt.",
    agenciaTransporteLink: "Agence de transport Link",
    fechaCarga: "F. Livraison prévue",
    fechaEntrega: "F. Livraison",
    fechaPrevExp: "Date estimée d'expédition",
    filtrarClientes: "Filtrer par client",
    riesgos: "Risques",
    riesgosDesc: "Portefeuille de risques clients",
    fechaSituacion: "F. Situation",
    fechaPedido: "Date de commande",
    leyenda: "Légende",
    presupuestoLeyenda: "Budget non confirmé",
    introducidoLeyenda: "Ordonnance introduite",
    pedidoEnviado: "Demande envoyée",
    pedidoConfirmado: "Commande confirmée",
    pedidoEnPreparacion: "Commande en préparation",
    pedidoRetenido: "Ordonnance retenue",
    enPreparacionLeyenda: "En préparation",
    planificadoLeyenda: "Production prévue",
    enFabricacionLeyenda: "Fabrication incitée",
    fabricadoLeyenda: "Fabriqué",
    enFabricacion: "En production",
    enviadoLeyenda: "Envoyé à",
    clientesSeleccionados: "clients sélectionnés",
    busquedaPorCliente: "Recherche par client",
    useAdvancedFilters: "Utilisation de filtres avancés",
    filterActions: "Actions de filtrage",
    busquedaPorRepresentante: "Recherche par représentant",
    cif: "CIF",
    zonaDesc: "Sélectionner une zone",
    provinciaDesc: "Sélectionner une province",
    clienteSeleccionadoTabla: "Client à afficher dans le tableau",
    seleccionarCliente: "Sélection des clients",
    numRegPagina: "Nombre d'enregistrements par page:",
    numPedidosPagina: "Nombre de commandes par page :",
    numCertifPagina: "Nombre de certificats par page",
    numRecogidas: "Nombre de collections par page",
    numEntradas: "Nombre d'entrées par page",
    numPedidos: "Nombre de commandes par page",
    numRecogidasEntradas: "Nombre de ramassages/entrées par page",
    factText: "Nombre de factures par page",
    entregasRecogidasTransitos: "Statut de l'enlèvement et de la livraison",
    contTratamientos: "Contrats Traitements",
    certificadoMedioAmbiental: "Certificats environnementaux",
    numAlbaran: "Numéro du bon de livraison",
    albaranTrans: "Note de livraison du transit",
    ticketPesada: "Ticket Pesada",
    numDI: "Nombre de DI",
    apoDI: "DI",
    advancedFilters: "Filtres avancés",
    codCliente: "Code client",
    centroTrabajo: "Centre de travail",
    codLER: "Code LER",
    tipoPedido: "Type",
    recogidasDesc: "Table de collection",
    entregasDesc: "Table de livraison",
    pedidosDesc: "Tableau de commande",
    transitosDesc: "Tableau des transactions",
    recogidasBtn: "Collections",
    entregasBtn: "Livraisons",
    pedidosBtn: "Demandes",
    transitosBtn: "Tous",
    rolDesc: "Gestion des rôles",
    rolTable: "Rôles",
    tiposUsersText: "Types d'utilisateurs",
    confAlmacenes: "Configurer Entrepôts et Emplacements",
    albaranBtn: "Bon de livraison",
    docIdBtn: "D.I.",
    ticketBtn: "Billet",
    ticketImg: "Photos Billet",
    fotoBtn: "Photographies",
    docAdj: "Documents joints",
    todosBtn: "Tous",
    descargasDesc: "Télécharger les documents de gestion",
    validateDesc: "Valider/Rejeter le service",
    numCertificado: "Numéro de certificat",
    avisoTipoPedido: "T. Ordre non sélectionné",
    avisoTipoPedidoDesc: "Vous devez sélectionner un type de commande",
    mesFinal: "Dernier mois",
    mesInicial: "Mois initial",
    mes: "Mes",
    codigoLER: "Code LER",
    destino: "Destination",
    tratamiento: "Traitement",
    uniMed: "UM",
    reciclaje: "% de recyclage",
    checkValido: "Échus",
    factClte: "Bons de livraison des clients",
    factClteDesc: "Rapport sur les bons de livraison en souffrance",
    factProv: "Factures fournisseurs impayées",
    stockArticulo: "Consultation de Stock et Commandes d'Achat",
    descStockArticulo: "Rapport sur le stock disponible, le potentiel et les commandes d'achat",
    factProvDesc: "Rapport sur les factures fournisseurs en souffrance",
    equery: "Equery",
    equeryDesc: "Programme Expert Query",
    albProv: "Bons de livraison du fournisseur",
    albProvDesc: "Rapport sur les bons de livraison en souffrance des fournisseurs",
    contTratamientosDesc: "Rapport sur les contrats de traitement",
    facturasClientes: "Bons de livraison à facturer au client",
    albaranesProv: "Bons de livraison à facturer au fournisseur",
    carrito: "carrito",
    tienda: "Boutique",
    familia: "Famille",
    familias: "Familles",
    subFamilias: "Sous-familles",
    arbol: "Arbre",
    categoria: "Catégorie",
    categorias: "Catégories",
    productos: "Produits",
    productoos: "produit/s",
    paraBusqueda: "Pour la recherche",
    hay: "foin",
    caracteristicas: "Caractéristiques",
    productosMismaFamilia: "Produits de la même famille",
    anadir: "Ajouter",
    fichaProducto: "Fiche produit",
    todoCatalogo: "Tout le catalogue",
    categoriaActual: "Catégorie actuelle",
    opcionesBusqueda: "Recherche par défaut dans :",
    filtros: "Filtres",
    catalogo: "Catalogue",
    irAlCarrito: "Aller au panier",
    tramitarPedido: "Traitement de la demande",
    seguirComprando: "Poursuivre les achats",
    vaciarElCarrito: "Vider le chariot",
    existeCarrito: "Un panier est en cours de traitement, souhaitez-vous le récupérer pour finaliser l'achat ?",
    empiezaCompra: "Commencer à acheter",
    noHayProductosCarrito: "Il n'y a aucun produit dans votre panier",
    totalProductos: "LE TOTAL DES PRODUITS :",
    total: "Total",
    borradoProducto: "Voulez-vous supprimer le produit sélectionné ?",
    borradoProductoCorto: "Voulez-vous supprimer le produit ?",
    vaciadoProducto: "Souhaitez-vous vider le chariot ?",
    miCarrito: "Mi carrito :",
    productosEnTotal: "Total des produits",
    pedido: "Commande web",
    tipoPed: "T. Commande",
    nuevo: "Nouveau",
    borrar: "Foreurs",
    filtrar: "Filtrer",
    observaciones: "Remarques",
    observationDesc: "Écrivez vos observations ici...",
    numeroPresupuesto: "Numéro de budget",
    empresa: "Entreprise",
    empresaFiscal: "Société fiscale",
    cliente: "Cliente",
    otrosFiltros: "Autres filtres",
    clienteInicial: "Cliente",
    clienteFinal: "Client final",
    sucursal: "Branche",
    codSucursal: "Code de la branche",
    seleccionaUnaSucursal: "Sélectionner une branche",
    fechaCreacion: "Date Budget",
    checkBorradoPresupuestos: "Êtes-vous sûr de vouloir supprimer le(s) budget(s) ?",
    checkBorradoLineaPresupuestos: "Êtes-vous sûr de vouloir supprimer la ligne budgétaire ?",
    razonSocial: "Nom de l'entreprise",
    editar: "Editer",
    imprimir: "Imprimir",
    excel: "Excel",
    resumenPresupuesto: "Résumé du budget",
    activarFiltro: "Activer/Désactiver",
    continuar: "Sauvegarder et continuer",
    saveAndExit: "Sauvegarder et quitter",
    volver: "Précédent",
    salir: "Salir",
    crear: "Crear",
    codigo: "Code",
    debeSeleccionar: "Vous devez sélectionner un élément",
    debeSeleccionarFecha: "Vous devez sélectionner une date",
    asistentePresupuesto: "Assistant budgétaire",
    asistenteNuevoPresupuesto: "Assistant Nouveau Budget",
    procesando: "Traitement",
    empresaCliente: "Client et succursale",
    seleccionEmpresaCliente: "Sélectionner le client et l'agence pour le devis",
    datosPresupuesto: "Budget de l'en-tête",
    datosCabeceraPresupuesto: "Saisir les données d'en-tête du budget",
    fecha: "Date",
    fechaAsignada: "F. commande",
    fechaAceptacion: "Date d'acceptation",
    plazoEntrega: "Délai de livraison",
    Representante: "Représentant",
    representante: "Représentant",
    representanteInicial: "Représentant initial",
    representanteFinal: "Représentant final",
    formaPago: "Mode de paiement",
    referencia: "Référence",
    fechaVigencia: "Date d'entrée en vigueur",
    descuento: "Remise",
    descuentoPP: "Remise PP",
    descuentoRappel: "Rabais sur le rappel",
    fechaVigenciaMayorFechaPedido: "La date d'entrée en vigueur ne peut être inférieure à la date du budget.",
    plazoEntrgaMayorFechaPedido: "Le délai de livraison ne peut être inférieur à la date du devis.",
    articulos: "Détails du budget",
    lineasPresupuesto: "Saisissez les lignes budgétaires et vos commentaires",
    linea: "Ligne",
    producto: "Produit",
    cantidad: "Cantidad",
    cantidadUMP: "Quantité (UMP)",
    cantidadUMV: "Cantidad(UMV)",
    tarifa: "Tarifa",
    ume: "UME",
    precio: "Prix",
    dto: "Dto",
    brutoNeto: "Gross / Grandson",
    precioNeto: "Prix net",
    importe: "Importation",
    agrupaciones: "Groupements",
    agrupacion: "Regroupement",
    orden: "Ordre",
    nombreNuevaAgrupacion: "Nouveau nom de groupe",
    checkBorradoAgrupaciones: "Êtes-vous sûr de vouloir supprimer le(s) groupe(s) ?",
    sinAgrupacion: "Pas de regroupement",
    sinBrutoNeto: "Non Brut / Net",
    sinTarifa: "Sin Tarifa",
    sinDescuento: "Pas de réduction",
    guardar: "Guardar",
    bruto: "Brut",
    neto: "Neto",
    buscador: "Chercheur",
    buscadorProductos: "Recherche de produits",
    buscadorAvanzado: "Recherche Avancée",
    volverAsistente: "Retour à l'assistante",
    busquedaArticulos: "Recherche d'articles",
    elementosSeleccionados: "Éléments sélectionnés",
    noElementosSeleccionados: "il n'y a pas d'éléments sélectionnés",
    resumen: "Résumé du budget",
    pantallaResumen: "Écran récapitulatif des données du budget préparé",
    enviar: "Envoyer",
    pasarPedido: "Passer une commande",
    presupuestoPasadoPedido: "Le budget a été déplacé à l'ordre du jour",
    filtroPresupuestos: "Filtrer les budgets",
    filtroClient: "Filtrer les clients",
    numPresu: "Nombre Budget",
    numPresupIni: "Nombre Budget initial",
    numPresupFin: "Nombre Budget final",
    fechaCreacionIni: "Date de début",
    fechaCreacionFin: "Date limite",
    fechaAceptacionIni: "Date de l'acceptation initiale",
    fechaAceptacionFin: "Date d'acceptation finale",
    mayorIgual: "supérieur ou égal à",
    menorIgual: "inférieur ou égal à",
    y: "y",
    nombreEmpresa: "Nom de l'entreprise",
    nombreCliente: "Nombre cliente",
    nombreProv: "Nom du fournisseur",
    nombreSucursal: "Nom de la branche",
    estados: "État/s",
    estado: "État",
    estadoEnvio: "État de l'envoi",
    retenido: "Conservé",
    aceptado: "Accepté",
    anulado: "Annulé",
    estadoFabricacion: "État d'avancement de la fabrication",
    estadoPedido: "État requis",
    fabricacion: "En production",
    pedidosPendientes: "Commandes en cours",
    selectPresupuestos: "Budgets",
    selectEnFabricacion: "En production",
    selectEnviados: "Envoyé à",
    servidos: "Demandes envoyées",
    pendientesPlanificar: "A planifier",
    planificadaFabricacion: "Production prévue",
    planificado: "Prévu",
    fabricado: "Fabriqué",
    extraidaLista: "Liste de préparation extraite",
    actualizadaLista: "Liste de préparation mise à jour",
    preparadoFacturacion: "Préparation de la facturation",
    actualizadoFacturacion: "Mise à jour de la facturation",
    asignadoEtiquetas: "Étiquettes attribuées",
    presupInicialMayorFinal: "Nombre de budgets initiaux supérieurs aux budgets finaux",
    fechaInicialMayorFinal: "Date de début supérieure à la date de fin",
    aplicar: "Appliquer",
    miCuenta: "Mon compte",
    mesEjercicioInicial: "Mois/Année Initiale",
    mesEjercicioFinal: "Mois/Année finale",
    mesEjercicioComparadoIni: "Mois/année comparée Initiale",
    mesEjercicioComparadoFin: "Mois/année de la comparaison Final",
    estProvRepre: "STATISTIQUES PROVINCE/REPRÉSENTANT",
    estProvRepreDesc: "Statistiques par province et par représentant",
    EstadsProvRepre: "Statistiques par province et par représentant",
    tipoRepresentante: "Type de rapport",
    ejercicio: "Exercice",
    recEntrTran: "Statut de l'enlèvement et de la livraison",
    recEntrTranDesc: "Rapport permettant de vérifier l'état des encaissements et des livraisons.",
    certMed: "Certificat environnemental",
    certMedDesc: "Certificat environnemental",
    userFolder: "Demande de renseignements sur le portefeuille de clients",
    userFolderDesc: "Rapport pour examen",
    incidencia: "Défense des intérêts",
    diasDplazo: "Jours de la date limite",
    diasDplazoHasta: "Jours de retard jusqu'à",
    nDarticulosArti: "N. Articles/Articles",
    nPedido: "N. Demande",
    fPedido: "F. Demande",
    fPedidoIniOFin: "F. Demande initiale ou finale",
    fCompromisoIniOFin: "F. Engagement initial ou définitif",
    fCompromisoEntrega: "F. Livraison de l'engagement",
    fPrevistaIniFabricacion: "F. Départ prévu Fab.",
    gFuncionalField: "G. Fonctionnel/Service/Section/Opération",
    gFuncional1: "Groupe fonctionnel 1",
    gFuncional2: "Groupe fonctionnel 2",
    gFuncional3: "Groupe fonctionnel 3",
    gFuncional4: "Groupe fonctionnel 4",
    fConfirmacion: "F. Confirmation",
    fPlanificacion: "F. Planification",
    fAlbaran: "F. Albarán",
    soloConRetraso: "Seulement avec du retard",
    ordenDeFabricacion: "Ordre de fabrication",
    nDiasFabricacion: "Nombre de jours de production",
    poweredDatadec: "Propulsé par DATADEC, S.A.",
    ordenesFabricacion: "Ordres de fabrication",
    consultarOrdenesFabricacion: "Consulter les ordres de fabrication",
    consultaOrdenesFabricacionDesc: "Consulter les ordres de fabrication",
    cargandoContenido: "Chargement du contenu",
    cargandoFechaDefecto: "La recherche de contenu dans le",
    cargandoFechaDefectoAnterior: " jours précédents",
    nuevoUsuario: "Nouvel utilisateur",
    anyadir: "Ajouter",
    descargarProforma: "D. Proforma",
    facturaCsv: "D. FacturaCsv",
    cambiar: "Changer",
    cambioEmpresaTexto1: "Vous êtes dans l'entreprise :",
    cambioEmpresaTexto2: "Pour participer, vous devez être dans le",
    cambioEmpresaTexto3: " Voulez-vous changer d'entreprise ?",
    avisoFiltroCliente: "Filtrage par client partenaire automatique activé",
    avisoFiltroRepresentante: "Le filtrage par représentant associé est activé, utilisez le bouton de recherche pour voir les résultats.",
    avisoFiltroAdministrador: "Filtrez par client, représentant ou deux des autres champs pour obtenir des résultats.",
    seleccion: "La sélection",
    descargarSeleccion: "Télécharger la sélection",
    errorCambioEmpresa: "Erreur lors du changement de société",
    errorComprobarEmpresa: "Erreur lors du contrôle de l'entreprise",
    enero: "Janvier",
    febrero: "Février",
    marzo: "Mars",
    abril: "Avril",
    mayo: "Mayo",
    junio: "Junio",
    julio: "Juillet",
    agosto: "Août",
    septiembre: "Septembre",
    octubre: "Octobre",
    noviembre: "Novembre",
    diciembre: "Décembre",
    descargandoExcel: "Télécharger Excel",
    descargandoContenido: "Cela peut prendre quelques minutes, veuillez patienter.",
    notValidDate: "Dates non valables !",
    notValidDateDesc: "Vérifiez les dates !",
    notFoundDefault: "Aucun résultat !",
    notFoundDefaultDesc: "Aucun résultat trouvé",
    notCentrosFoundDesc: "Aucun centre partenaire trouvé",
    errorCode: "Code passé erroné",
    requiredDate: "Le champ est obligatoire !",
    urlNotFound: "Pas de dossier !",
    urlNotFoundDesc: "Ce certificat ne contient pas de pièce jointe",
    avisoFactura: "Filtres nécessaires !",
    avisoFacturaDesc: "Il est nécessaire de faire passer un représentant ou un client.",
    notFoundReport: "Aucun rapport n'a été trouvé !",
    notFoundReportDesc: "Rapport avec données antérieures introuvables",
    estadoVentaNotFound: "Aucun rapport n'a été trouvé !",
    estadoVentaNotFoundDesc: "Rapport avec données antérieures introuvables",
    vencimientoNotFound: "Aucun rapport n'a été trouvé !",
    vencimientoNotFoundDesc: "Rapport avec données antérieures introuvables",
    vencimientoNotFoundError: "Erreur de connexion !",
    vencimientoNotFoundErrorDesc: "Erreur de connexion, réessayer plus tard.",
    errorDefault: "Erreur de connexion !",
    errorDefaultDesc: "Erreur dans la connexion au rapport",
    errorNumRecogidas: "Erreur de téléchargement !",
    errorNumRecogidasDesc: "Pas plus de 1100 résultats peuvent être téléchargés",
    errorInsertUser: "Erreur de mise à jour de l'utilisateur !",
    errorInsertUserDesc: "Vérifiez que tout est correct !",
    errorInsertUser500: "L'utilisateur n'a pas pu être mis à jour correctement",
    errorDeleteUser: "Erreur lors de la suppression d'un utilisateur !",
    insercionRoles: "Changements apportés !",
    insercionRolesDesc: "Dates correctement insérées",
    insercionRolesDescAct: "Dates correctement mises à jour",
    errorRoles: "Erreur trouvée !",
    errorRolesDesc: "Absence de gestion des dates",
    notLoginDefault: "Erreur de connexion",
    notLoginDefaultDesc: "Échec de la connexion",
    notFacturaFound: "Pas de factures",
    notFacturaFoundDesc: "Aucune facture trouvée",
    notAlbaranFound: "Pas de bon de livraison",
    notAlbaranFoundDesc: "Aucun rapport n'a été trouvé pour ce bon de livraison.",
    notAlbaranFoundInPedDesc: "Il n'y a pas de bon de livraison associé à cette commande.",
    notDataLoginFound: "Absence de récupération des données",
    notDataLoginFoundDesc: "Impossible de récupérer les données",
    onePresupuesto: "Vous ne devez sélectionner qu'un seul budget",
    notStatusCorrect: "Vous ne pouvez pas modifier un budget qui a été accepté.",
    filtersAlert: "Filtres nécessaires",
    filtersClientSuc: "Il est nécessaire de passer un Client à votre Branche.",
    filtersClient: "Il est nécessaire de faire passer un Client.",
    filtersSuc: "Il est nécessaire de faire passer une branche.",
    delPres: "Erreur lors de la suppression du budget !",
    delPresDesc: "Le budget est accepté et ne peut plus être supprimé.",
    tipoCompVen: "Type de commande",
    noData: "Pas de résultats",
    searchPanel: "Recherche",
    compras: "Achats",
    ventas: "Ventas",
    transitos: "Transits",
    beneficio: "Bénéfice",
    proveedor: "Fournisseur",
    sucProveedor: "Fournisseur de la branche",
    matricula: "Inscription",
    precioMedio: "Prix moyen",
    transporte: "Transport",
    almacen: "Entrepôt",
    albaranTte: "Albarán TTe",
    costeTte: "Côtes TTE",
    importeTte: "Importe TTE",
    transportista: "Transportista",
    startsWidth: "Il commence par",
    equals: "Égalité",
    between: "Visiter",
    contains: "Contient",
    endsWith: "Se termine par",
    greaterThan: "Supérieure à",
    lessThan: "Moins de",
    lessThanOrEqual: "Inférieur ou égal à",
    notContains: "Il ne contient pas",
    notEqual: "Différents",
    greaterThanOrEqual: "Supérieur ou égal à",
    reset: "Limpiar",
    filterMonth: "Filtre sur le mois en cours",
    filtroAvzClte: "Filtre client avancé",
    filtroAvzPed: "Filtre de commande avancé",
    descargaExcel: "Télécharger Excel",
    alertsCancel: "Annuler",
    alertsAceptar: "Accepter",
    nuevaVersion: 'Une nouvelle version a été détectée. Vous souhaitez recharger la page?',
    selecBultoAlb: 'Sélectionnez un bordereau d’expédition',
    descagarExcel: 'Télécharger Excel',
    consultaDocEstadoPed: "Consulter les documents dans l'état des commandes",
    archivoEnviadoEmail: "Le fichier sera envoye a {email}"
  },
  it: {
    codTracking: "Tracking",
    numTicket: "Ticket PDA",
    fechaOC: "Data OC",
    stockArticulos: "Stock Articoli",
    ocPendientes: "Ordini di Acquisto in sospeso",
    descOcPendientes: "Rapporto sugli Ordini di Acquisto in sospeso da fatturare",
    noRetenido: "Non trattenuto",
    retenido: "Trattenuto",
    parcialmenteRetenido: "Parzialmente trattenuto",
    dptoConcepto: "Dipartimento/Concetto",
    actCorrectamente: "Dati aggiornati correttamente",
    centros: "Centri",
    centro: "Centro",
    familiaProv: "Cod. Famiglia",
    descFamiliaProv: "Desc Famiglia",
    idServicioWeb: "ID Servizio Portale",
    ordenCompra: "Ordine di acquisto",
    fechaPrevista: "Data prevista",
    cantidaPendiente: "Quantità in sospeso",
    imagen: "Immagine",
    stockDisponible: "Stock disponibile",
    stockPotencial: "Stock potenziale",
    ubicacion: "Ubicazione",
    lote: "Lotto",
    cantidadExistente: "Quantità esistente",
    ocMasReciente: "1ª Data OC",
    diasSinCambiosEnEstado: "Giorni trascorsi dall'ultima modifica dello stato dell'ordine.",
    diasAntiguedadDesc: "Giorni indietro utilizzati per il primo filtraggio di Ordini/Bolle di consegna.",
    activarFiltroDesc: "Eseguire automaticamente la ricerca nella query degli ordini.",
    documentos: "Documenti",
    pendiente: "In sospeso",
    datosPedido: "Dati dell'ordine",
    pedidoPendiente: "Ordine in sospeso",
    codigoCliente: "Codice cliente",
    datosGenerales: "Dati generali",
    descargas: "Download",
    validate: "Convalidare",
    deny: "Rifiutare",
    cancel: "Annullare",
    pedidoPlanificado: "Ordine pianificato",
    factura: "Fattura",
    albaran: "Bolla di consegna",
    proforma: "Proforma",
    poblacionEnvio: "Località di spedizione",
    poblacionFacturacion: "Località di fatturazione",
    poblacion: "Località",
    poblacionAlm: "Località magazzino",
    correo: "Email",
    direccion: "Indirizzo",
    direccionFacturacion: "Indirizzo di fatturazione",
    direccionEnvio: "Indirizzo di spedizione",
    datosFacturacion: "Dati di fatturazione",
    facturacion: "Fatturazione",
    datosEnvio: "Dati di spedizione",
    seleccionaUnArticulo: "Seleziona un articolo",
    lineasPedido: "Righe ordine",
    fechaRecepcionPedido: "Data ricezione ordine",
    numeroPedido: "Numero ordine",
    tipoPedidoDesc: "Tipo di ordine",
    descargarAlbaran: "Scarica bolla di consegna",
    descargarFactura: "Scarica fattura",
    generarCompra: "Genera Acquisto",
    generandoOrdenCompra: "Generazione Ordine di Acquisto",
    ocGenerada: "OA Generato",
    generarOC: "Genera OA",
    marcarTodos: "Seleziona Tutto",
    desmarcarTodos: "Deseleziona Tutto",
    noLineasSeleccionadas: "Nessuna riga selezionata",
    noLineasSeleccionadasDesc: "Devi selezionare almeno una riga per generare l'ordine di acquisto.",
    ocGeneradaExito: "Ordine di acquisto generato con successo",
    errorGenerarOC: "Errore nella generazione dell'ordine di acquisto",
    errorProcesarSolicitud: "Errore nell'elaborazione della richiesta",
    errorDesconocido: "Errore sconosciuto",
    errorConexion: "Errore di connessione",
    descProducto: "Desc Prodotto",
    seleccionaUnCliente: "Seleziona un cliente",
    seleccionaUnSucursal: "Seleziona una filiale",
    selectRepresentante: "Seleziona un rappresentante",
    selectProveedor: "Seleziona un fornitore",
    aplicarFiltrosYcomenzar: "Applica filtri e avvia ricerca",
    limpiarFiltros: "Pulisci filtri",
    OrderStatus: "Stato dell'ordine",
    Entered: "Inseriti",
    Served: "Consegnati",
    Invoiced: "Fatturati",
    Detained: "Trattenuti",
    Cancelled: "Annullati",
    initial: "iniziale",
    final: "finale",
    nombreRepresentante: "Nome rappresentante",
    country: "Paese",
    Province: "Provincia",
    province: "provincia",
    cambioEstilo: "Cambio stile",
    accessWithTokenDesc: "Accesso ai rapporti",
    accesoAplicacion: "Accesso al negozio web",
    gestionPresupuestos: "Portale per clienti",
    areaClientes: "Area clienti",
    usuario: "Utente",
    contrasenya: "Password",
    dominio: "Dominio",
    login: "LOGIN",
    iniciarSesion: "ACCEDI",
    cerrarSesion: "Disconnetti",
    noAcceso: "Questo utente non ha accesso consentito all'applicazione, contattare l'amministratore",
    noConfigurado: "Questo utente non è configurato correttamente, contattare l'amministratore",
    politicaPrivacidad1: "Sì, accetto la",
    politicaPrivacidad2: "Politica sulla privacy",
    accesoInformes: "Accesso ai rapporti",
    errorLoginText: "L'utente non esiste o la password non è valida",
    presupuestosPedidos: "Preventivi/Ordini",
    entradaPedidos: "Inserimento ordini",
    listaPresupuestos: "Elenco preventivi",
    buscarArt: "Cerca articolo per codice o denominazione",
    buscar: "Cerca",
    registrosPagina: "record per pagina",
    noResultados: "Non ci sono record per la ricerca effettuata",
    oResultados: "0 record",
    acciones: "Azioni",
    aceptar: "Accettare",
    cancelar: "Annullare",
    limpiar: "Pulisci",
    cerrar: "Chiudi",
    campoRequerido: "Questo campo è obbligatorio",
    elementoCorrecto: "Selezionare un elemento corretto",
    desconectar: "disconnetti",
    deseaDesconectar: "Sei sicuro di volerti disconnettere dall'applicazione?",
    sesionCancelada: "Sessione annullata. Accedi di nuovo all'applicazione.",
    noConexion: "Impossibile accedere temporaneamente al servizio. Se il problema persiste, contattare l'amministratore",
    si: "Sì",
    no: "No",
    noSeleccion: "Devi selezionare un elemento",
    presupuestos: "Preventivi",
    presupuestosDesc: "Rapporto preventivi",
    presupuesto: "Preventivo",
    descripcion: "Descrizione",
    informacion: "Informazioni",
    pdfNotFound: "PDF non trovati",
    pdfNotFoundDesc: "Si è verificato un problema durante la ricerca dei PDF",
    zipNotFound: "Errore nel download",
    zipNotFoundDesc: "Si è verificato un problema con il download dei file",
    responseFail: "Errore di connessione",
    responseFailDesc: "Si è verificato un problema nella connessione al server",
    usuarios: "Utenti",
    administracionUsuarios: "Gestione utenti",
    listaUsuarios: "Elenco utenti",
    datosUsuario: "Dati utente",
    tipoUsuario: "Tipo utente",
    asociacionUsuarios: "Associazione utenti",
    accesosUsuario: "Accessi",
    nombre: "Nome",
    email: "E-mail",
    telefono: "Telefono",
    usuarioActivo: "Utente attivo",
    usuarioActualizado: "L'utente è stato aggiornato correttamente",
    usuarioEliminado: "L'utente è stato eliminato correttamente",
    administrador: "Amministratore",
    activacionUsuario: "Per attivare un utente è necessario completare l'associazione dell'utente",
    datos: "Dati",
    asociacion: "Associazione",
    totales: "Totali",
    fechas: "Date",
    tipoUser: "Tipo utente",
    deleteItem: "Cancellazione in corso...",
    saveDetPres: "Salvataggio dettaglio preventivo",
    saveCabPres: "Salvataggio testata preventivo",
    iniCabPres: "Caricamento preventivi",
    iniCabArticulos: "Caricamento articoli",
    iniImpresPres: "Caricamento stampa",
    descargar: "Scaricare",
    cargo: "Addebito",
    abono: "Accredito",
    otros: "Altri",
    consultaPelikane: "Stato spedizione",
    comprasVentas: "Acquisti/Vendite",
    comprasVentasDesc: "Rapporto su acquisti e vendite",
    clienteSeleccionado: "Cliente selezionato:",
    dialogInfoCliente: "Informazioni cliente",
    dialogInfoPedido: "Informazioni ordine",
    cabeceraPedido: "Testata ordine",
    consultaOrdenesFabricacion: "Ordini di produzione",
    estadoPedidosAlbaran: "Stato ordini / Bolle di consegna",
    estadoPedidosAlbaranDesc: "Rapporto sullo stato degli ordini e delle bolle di consegna",
    estadisticasVentas: "Vendite per rappresentante/cliente/mese",
    estadisticasVentasDesc: "Rapporto vendite per rappresentante/cliente/mese",
    presupuestosInforme: "Rapporto sui preventivi",
    estadoVentas: "Stato vendite",
    estadoVentasDesc: "Rapporto per verificare lo stato delle vendite",
    reimpresionFacturas: "Ristampa fatture",
    reimpresionFacturasDesc: "Rapporto per stampare le fatture generate",
    estadoVencimientos: "Stato scadenza incassi",
    estadoVencimientosDesc: "Rapporto sullo stato delle scadenze",
    impagados: "Incassi scaduti e/o insoluti",
    impagadosDesc: "Rapporto per verificare lo stato dei pagamenti non ancora incassati",
    guardadoDatosPendiente: "Ci sono dati da salvare. Vuoi salvarli?",
    abrir: "Aprire",
    estadoPedidos: "Stato ordine",
    representanteInicialMayorFinal: "Numero rappresentante iniziale maggiore del finale",
    representanteVacio: "È necessario un codice rappresentante",
    clienteInicialMayorFinal: "Numero cliente iniziale maggiore del finale",
    clienteVacio: "È necessario un codice cliente",
    introducido: "Inserito",
    numeroFactura: "Numero fattura",
    accion: "Azione",
    descarga: "Download",
    fechaExpedicion: "Data emissione",
    fechaInicial: "Data iniziale",
    diasAntiguedad: "Giorni di anzianità",
    fechaInici: "Data inizio",
    fechaFinal: "Data finale",
    fechaVencimiento: "Data di scadenza",
    fechaInicialVencimiento: "Data scadenza iniziale",
    fechaFinalVencimiento: "Data scadenza finale",
    fechaInicialEntrega: "Data consegna iniziale",
    fechaFinalEntrega: "Data consegna finale",
    fechaFactura: "Data fattura",
    fechaInicialFactura: "Data fattura iniziale",
    fechaFinalFactura: "Data fattura finale",
    fechaInicialCliente: "Data cliente iniziale",
    fechaFinalCliente: "Data cliente finale",
    pedidos: "Ordini",
    tipoVenta: "Tipo di vendita",
    informes: "Rapporti",
    entrados: "Inseriti",
    pendienteServir: "In attesa di consegna",
    pendienteFacturar: "In attesa di fatturazione",
    facturados: "Fatturati",
    cargaAbonos: "Addebiti e accrediti",
    checkCargos: "Addebiti",
    checkAbonos: "Accrediti",
    todos: "Tutti",
    activos: "Attivi",
    pasivos: "Inattivi",
    inProcess: "In lavorazione",
    cerrado: "Chiuso",
    cerrada: "Chiusa",
    contados: "Contanti",
    creditos: "Crediti",
    articulo: "Articolo",
    obra: "Lavoro",
    articulosDesc: "Articoli",
    denominacion: "Denominazione",
    denomLer: "Denom. LERS",
    descTrat: "Descrizione trattamento",
    codTrat: "Codice trattamento",
    codResiduo: "Codice rifiuto",
    nomResiduo: "Rifiuto",
    codServicio: "Codice servizio",
    nomServicio: "Servizio",
    familiaArticulo: "Famiglia/Articolo",
    conceptoCliente: "Concetto(famiglia)/cliente",
    clienteConcepto: "Cliente/concetto(famiglia)",
    clienteFamilia12m: "Cliente/famiglia(12 mesi)",
    familiaCliente12m: "Famiglia/cliente(12 mesi)",
    ventasXRepresentateCliMes: "VENDITE PER RAPP./CLIENTE/MESE",
    nivel: "Livello",
    tipoListado: "Tipo elenco",
    listado: "Elenco",
    enPreparacion: "In preparazione",
    validando: "Convalida in corso",
    numeroFacturaCorto: "N° fattura",
    numeroAlbaranCorto: "N° bolla",
    numCertificadoCorto: "N° certificato",
    operTraslado: "Trasferimento",
    fechaVig: "Data fine validità",
    fechaContr: "Data contratto",
    numContr: "N° contratto",
    notfPrevia: "Notifica preventiva",
    titularOrigen: "Origine",
    titularDestino: "Destinazione",
    fechaAlbaran: "Data bolla",
    reviseFiltros: "Controllare l'errore rilevato nei filtri prima di scaricare il rapporto",
    reviseFiltrosBuscar: "Controllare l'errore rilevato nei filtri prima di avviare la ricerca",
    debeIndicarAlMenosUnoFiltro: "È necessario indicare almeno uno dei seguenti campi: Data iniziale, Codice rappresentante o Numero ordine",
    noExisteElemento: "Non esiste un elemento con questo codice",
    clientes: "Clienti",
    nombrClienteRaz: "Nome cliente / Ragione sociale",
    ClienteRaz: "Cliente / Ragione sociale",
    suReferencia: "S/Rif.",
    suReferenciaDesc: "Il suo riferimento",
    dias: "Giorni",
    situacion: "Situazione",
    agenciaTransporte: "Agenzia di trasporto",
    agente: "Agente",
    agenciaTte: "Agenzia trasporti",
    agenciaTransporteLink: "Link agenzia di trasporto",
    fechaCarga: "Data prevista spedizione",
    fechaEntrega: "Data consegna",
    fechaPrevExp: "Data prevista spedizione",
    filtrarClientes: "Filtra per clienti",
    riesgos: "Rischi",
    riesgosDesc: "Portafoglio rischi del cliente",
    fechaSituacion: "Data situazione",
    fechaPedido: "Data ordine",
    leyenda: "Legenda",
    presupuestoLeyenda: "Preventivo non confermato",
    introducidoLeyenda: "Ordine inserito",
    pedidoEnviado: "Ordine inviato",
    pedidoConfirmado: "Ordine confermato",
    pedidoEnPreparacion: "Ordine in preparazione",
    pedidoRetenido: "Ordine trattenuto",
    enPreparacionLeyenda: "In preparazione",
    planificadoLeyenda: "Produzione pianificata",
    enFabricacionLeyenda: "Produzione avviata",
    fabricadoLeyenda: "Prodotto",
    enFabricacion: "In produzione",
    enviadoLeyenda: "Spedito",
    clientesSeleccionados: "clienti selezionati",
    busquedaPorCliente: "Ricerca per cliente",
    useAdvancedFilters: "Usa filtri avanzati",
    filterActions: "Azioni filtri",
    busquedaPorRepresentante: "Ricerca per rappresentante",
    cif: "Codice fiscale",
    zonaDesc: "Seleziona una zona",
    provinciaDesc: "Seleziona una provincia",
    clienteSeleccionadoTabla: "Cliente da mostrare in tabella",
    seleccionarCliente: "Selezione cliente",
    numRegPagina: "Numero record per pagina:",
    numPedidosPagina: "Numero ordini per pagina:",
    numCertifPagina: "Numero certificati per pagina",
    numRecogidas: "Numero ritiri per pagina",
    numEntradas: "Numero entrate per pagina",
    numPedidos: "Numero ordini per pagina",
    numRecogidasEntradas: "Numero ritiri/entrate per pagina",
    factText: "Numero fatture per pagina",
    entregasRecogidasTransitos: "Stato ritiri e consegne",
    contTratamientos: "Contratti trattamenti",
    certificadoMedioAmbiental: "Certificati ambientali",
    numAlbaran: "Numero bolla",
    albaranTrans: "Bolla di transito",
    ticketPesada: "Ticket pesata",
    numDI: "Numero DI",
    apoDI: "DI",
    advancedFilters: "Filtri avanzati",
    codCliente: "Codice cliente",
    centroTrabajo: "Centro di lavoro",
    codLER: "Codice LER",
    tipoPedido: "Tipo",
    recogidasDesc: "Tabella ritiri",
    entregasDesc: "Tabella consegne",
    pedidosDesc: "Tabella ordini",
    transitosDesc: "Tabella transazioni",
    recogidasBtn: "Ritiri",
    entregasBtn: "Consegne",
    pedidosBtn: "Ordini",
    transitosBtn: "Tutte",
    rolDesc: "Gestione ruoli",
    rolTable: "Ruoli",
    confAlmacenes: "Configura magazzini e ubicazioni",
    tiposUsersText: "Tipi di utente",
    albaranBtn: "Bolla",
    docIdBtn: "D.I.",
    ticketBtn: "Ticket",
    ticketImg: "Foto ticket",
    fotoBtn: "Fotografie",
    docAdj: "Documenti allegati",
    todosBtn: "Tutti",
    descargasDesc: "Download dei documenti relativi alla gestione",
    validateDesc: "Convalidare/Annullare servizio",
    numCertificado: "Numero certificato",
    avisoTipoPedido: "Tipo ordine non selezionato",
    avisoTipoPedidoDesc: "È necessario selezionare un tipo di ordine",
    mesFinal: "Mese finale",
    mesInicial: "Mese iniziale",
    mes: "Mese",
    codigoLER: "Codice LER",
    destino: "Destinazione",
    tratamiento: "Trattamento",
    uniMed: "UM",
    reciclaje: "% Riciclaggio",
    checkValido: "Scaduti",
    factClte: "Bolle clienti",
    factClteDesc: "Rapporto bolle clienti in sospeso",
    factProv: "Fatture fornitore in sospeso",
    stockArticulo: "Consultazione stock e ordini di acquisto",
    descStockArticulo: "Rapporto stock disponibile, potenziale e ordini di acquisto",
    factProvDesc: "Rapporto fatture fornitore in sospeso",
    equery: "Equery",
    equeryDesc: "Programma Expert Query",
    albProv: "Bolle fornitori",
    albProvDesc: "Rapporto bolle fornitori in sospeso",
    contTratamientosDesc: "Rapporto contratti trattamenti",
    facturasClientes: "Bolle clienti in attesa di fatturazione",
    albaranesProv: "Bolle fornitori in attesa di fatturazione",
    carrito: "Carrello",
    tienda: "Negozio",
    familia: "Famiglia",
    familias: "Famiglie",
    subFamilias: "Sottofamiglie",
    arbol: "Albero",
    categoria: "Categoria",
    categorias: "Categorie",
    productos: "Prodotti",
    productoos: "prodotto/i",
    paraBusqueda: "Per la ricerca",
    hay: "ci sono",
    caracteristicas: "Caratteristiche",
    productosMismaFamilia: "Prodotti della stessa famiglia",
    anadir: "Aggiungere",
    fichaProducto: "Scheda prodotto",
    todoCatalogo: "Tutto il catalogo",
    categoriaActual: "Categoria attuale",
    opcionesBusqueda: "Ricerca predefinita in:",
    filtros: "Filtri",
    catalogo: "Catalogo",
    irAlCarrito: "Vai al carrello",
    tramitarPedido: "Elabora ordine",
    seguirComprando: "Continua a comprare",
    vaciarElCarrito: "Svuota il carrello",
    existeCarrito: "Esiste un carrello in sospeso, vuoi recuperarlo per completare l'acquisto?",
    empiezaCompra: "Inizia a comprare",
    noHayProductosCarrito: "Non ci sono prodotti nel carrello",
    totalProductos: "TOTALE PRODOTTI:",
    total: "Totale",
    borradoProducto: "Vuoi eliminare il prodotto selezionato?",
    borradoProductoCorto: "Vuoi eliminare il prodotto?",
    vaciadoProducto: "Vuoi svuotare il carrello?",
    miCarrito: "Il mio carrello:",
    productosEnTotal: "prodotti in totale",
    pedido: "Ordine",
    pedidoWeb: "Ordine web",
    tipoPed: "T. Ordine",
    nuevo: "Nuovo",
    borrar: "Eliminare",
    filtrar: "Filtrare",
    observaciones: "Osservazioni",
    observationDesc: "Scrivi qui le tue osservazioni...",
    numeroPresupuesto: "Numero preventivo",
    empresa: "Azienda",
    empresaFiscal: "Azienda fiscale",
    cliente: "Cliente",
    otrosFiltros: "Altri filtri",
    clienteInicial: "Cliente iniziale",
    clienteFinal: "Cliente finale",
    sucursal: "Filiale",
    codSucursal: "Codice filiale",
    seleccionaUnaSucursal: "Seleziona una filiale",
    fechaCreacion: "Data preventivo",
    checkBorradoPresupuestos: "Sei sicuro di voler eliminare il/i preventivo/i?",
    checkBorradoLineaPresupuestos: "Sei sicuro di voler eliminare la riga del preventivo?",
    razonSocial: "Ragione sociale",
    editar: "Modificare",
    imprimir: "Stampare",
    excel: "Excel",
    resumenPresupuesto: "Riepilogo preventivo",
    activarFiltro: "Attivare/Disattivare",
    continuar: "Salvare e continuare",
    saveAndExit: "Salvare e uscire",
    volver: "Indietro",
    salir: "Uscire",
    crear: "Creare",
    codigo: "Codice",
    debeSeleccionar: "Devi selezionare un elemento",
    debeSeleccionarFecha: "Devi selezionare una data",
    asistentePresupuesto: "Assistente preventivo",
    asistenteNuevoPresupuesto: "Assistente nuovo preventivo",
    procesando: "Elaborazione in corso",
    empresaCliente: "Cliente e filiale",
    seleccionEmpresaCliente: "Seleziona cliente e filiale per il preventivo",
    datosPresupuesto: "Testata preventivo",
    datosCabeceraPresupuesto: "Inserisci i dati della testata del preventivo",
    fecha: "Data",
    fechaAsignada: "Data ordine",
    fechaAceptacion: "Data accettazione",
    plazoEntrega: "Termine di consegna",
    Representante: "Rappresentante",
    representante: "Rappresentante",
    multisucursal: "Multi-filiale",
    representanteInicial: "Rappresentante iniziale",
    representanteFinal: "Rappresentante finale",
    formaPago: "Metodo di pagamento",
    referencia: "Riferimento",
    fechaVigencia: "Data validità",
    descuento: "Sconto",
    descuentoPP: "Sconto pronto pagamento",
    descuentoRappel: "Sconto a scalare",
    fechaVigenciaMayorFechaPedido: "La data di validità non può essere precedente alla data del preventivo",
    plazoEntrgaMayorFechaPedido: "Il termine di consegna non può essere precedente alla data del preventivo",
    articulos: "Dettaglio preventivo",
    lineasPresupuesto: "Inserisci le righe del preventivo e i relativi commenti",
    linea: "Riga",
    producto: "Prodotto",
    cantidad: "Quantità",
    cantidadUMP: "Quantità(UMP)",
    cantidadUMV: "Quantità(UMV)",
    tarifa: "Tariffa",
    ume: "UME",
    precio: "Prezzo",
    dto: "Sconto",
    brutoNeto: "Lordo / Netto",
    precioNeto: "Prezzo netto",
    importe: "Importo",
    agrupaciones: "Raggruppamenti",
    agrupacion: "Raggruppamento",
    orden: "Ordine",
    nombreNuevaAgrupacion: "Nome nuovo raggruppamento",
    checkBorradoAgrupaciones: "Sei sicuro di voler eliminare il/i raggruppamento/i?",
    sinAgrupacion: "Senza raggruppamento",
    sinBrutoNeto: "Senza Lordo / Netto",
    sinTarifa: "Senza tariffa",
    sinDescuento: "Senza sconto",
    guardar: "Salvare",
    bruto: "Lordo",
    neto: "Netto",
    buscador: "Motore di ricerca",
    buscadorProductos: "Ricerca prodotti",
    buscadorAvanzado: "Ricerca avanzata",
    volverAsistente: "Torna all'assistente",
    busquedaArticulos: "Ricerca articoli",
    elementosSeleccionados: "Elementi selezionati",
    noElementosSeleccionados: "Nessun elemento selezionato",
    resumen: "Riepilogo preventivo",
    pantallaResumen: "Schermata riepilogo con i dati del preventivo elaborato",
    enviar: "Inviare",
    pasarPedido: "Trasforma in ordine",
    presupuestoPasadoPedido: "Il preventivo è stato trasformato in ordine",
    filtroPresupuestos: "Filtra preventivi",
    filtroClient: "Filtra cliente",
    numPresu: "Numero preventivo",
    numPresupIni: "Numero preventivo iniziale",
    numPresupFin: "Numero preventivo finale",
    fechaCreacionIni: "Data iniziale",
    fechaCreacionFin: "Data finale",
    fechaAceptacionIni: "Data accettazione iniziale",
    fechaAceptacionFin: "Data accettazione finale",
    mayorIgual: "maggiore o uguale a",
    menorIgual: "minore o uguale a",
    y: "e",
    nombreEmpresa: "Nome azienda",
    nombreCliente: "Nome cliente",
    nombreProv: "Nome fornitore",
    nombreSucursal: "Nome filiale",
    estados: "Stato/i",
    estado: "Stato",
    estadoEnvio: "Stato spedizione",
    retenido: "Trattenuto",
    aceptado: "Accettato",
    anulado: "Annullato",
    estadoFabricacion: "Stato produzione",
    estadoPedido: "Stato ordine",
    fabricacion: "In produzione",
    pedidosPendientes: "Ordini in sospeso",
    selectPresupuestos: "Preventivi",
    selectEnFabricacion: "In produzione",
    selectEnviados: "Spediti",
    servidos: "Ordini spediti",
    pendientesPlanificar: "In attesa di pianificazione",
    planificadaFabricacion: "Produzione pianificata",
    planificado: "Pianificato",
    fabricado: "Prodotto",
    extraidaLista: "Estratto elenco preparazione",
    actualizadaLista: "Elenco preparazione aggiornato",
    preparadoFacturacion: "Preparato per fatturazione",
    actualizadoFacturacion: "Fatturazione aggiornata",
    asignadoEtiquetas: "Etichette assegnate",
    presupInicialMayorFinal: "Numero preventivo iniziale maggiore del finale",
    fechaInicialMayorFinal: "Data iniziale maggiore del finale",
    aplicar: "Applicare",
    miCuenta: "Il mio account",
    mesEjercicioInicial: "Mese/Esercizio iniziale",
    mesEjercicioFinal: "Mese/Esercizio finale",
    mesEjercicioComparadoIni: "Mese/Esercizio comparato iniziale",
    mesEjercicioComparadoFin: "Mese/Esercizio comparato finale",
    estProvRepre: "STATISTICHE PROVINCIA/RAPPRESENTANTE",
    estProvRepreDesc: "Statistiche per provincia e rappresentante",
    EstadsProvRepre: "Statistiche per provincia e rappresentante",
    tipoRepresentante: "Tipo rapporto",
    ejercicio: "Esercizio",
    recEntrTran: "Stato ritiri e consegne",
    recEntrTranDesc: "Rapporto per verificare lo stato di ritiri e consegne",
    certMed: "Certificato ambientale",
    certMedDesc: "Certificato di Medio Ambiente",
    userFolder: "Consultazione portafoglio clienti",
    userFolderDesc: "Rapporto per revisione",
    incidencia: "Incidente",
    diasDplazo: "Giorni di termine",
    diasDplazoHasta: "Giorni di termine fino a",
    nDarticulosArti: "N. articoli/Articoli",
    nPedido: "N. ordine",
    fPedido: "Data ordine",
    fPedidoIniOFin: "Data ordine iniziale o finale",
    fCompromisoIniOFin: "Data impegno iniziale o finale",
    fCompromisoEntrega: "Data impegno consegna",
    fPrevistaIniFabricacion: "Data prevista inizio prod.",
    gFuncionalField: "Gruppo funzionale/Servizio/Sezione/Operazione",
    gFuncional1: "Gruppo funzionale 1",
    gFuncional2: "Gruppo funzionale 2",
    gFuncional3: "Gruppo funzionale 3",
    gFuncional4: "Gruppo funzionale 4",
    fConfirmacion: "Data conferma",
    fPlanificacion: "Data pianificazione",
    fAlbaran: "Data bolla",
    soloConRetraso: "Solo in ritardo",
    ordenDeFabricacion: "Ordine di produzione",
    nDiasFabricacion: "N° giorni produzione",
    poweredDatadec: "Powered by DATADEC, S.A.",
    ordenesFabricacion: "Ordini di produzione",
    consultarOrdenesFabricacion: "Consultare ordini di produzione",
    consultaOrdenesFabricacionDesc: "Consultare ordini di produzione",
    cargandoContenido: "Caricamento contenuto",
    cargandoFechaDefecto: "Ricerca contenuto degli ultimi ",
    cargandoFechaDefectoAnterior: " giorni precedenti",
    nuevoUsuario: "Nuovo utente",
    anyadir: "Aggiungere",
    descargarProforma: "Scaricare proforma",
    facturaCsv: "Scaricare fattura CSV",
    cambiar: "Cambiare",
    cambioEmpresaTexto1: "Sei nell'azienda: ",
    cambioEmpresaTexto2: ", per entrare devi essere in ",
    cambioEmpresaTexto3: " Vuoi cambiare azienda?",
    avisoFiltroCliente: "Filtro cliente associato automatico attivato",
    avisoFiltroRepresentante: "Filtro rappresentante associato attivato, usa il pulsante cerca per vedere i risultati",
    avisoFiltroAdministrador: "Filtra per cliente, rappresentante o due degli altri campi per ottenere risultati",
    seleccion: "Selezione",
    descargarSeleccion: "Scaricare selezione",
    errorCambioEmpresa: "Errore nel cambio azienda",
    errorComprobarEmpresa: "Errore nel controllo azienda",
    enero: "Gennaio",
    febrero: "Febbraio",
    marzo: "Marzo",
    abril: "Aprile",
    mayo: "Maggio",
    junio: "Giugno",
    julio: "Luglio",
    agosto: "Agosto",
    septiembre: "Settembre",
    octubre: "Ottobre",
    noviembre: "Novembre",
    diciembre: "Dicembre",
    descargandoExcel: "Download Excel in corso",
    descargandoContenido: "Questo può richiedere alcuni minuti, attendere prego",
    notValidDate: "Date non valide!",
    notValidDateDesc: "Controlla le date!",
    notFoundDefault: "Nessun risultato!",
    notFoundDefaultDesc: "Non sono stati trovati risultati",
    notCentrosFoundDesc: "Non sono stati trovati centri associati",
    errorCode: "Codice errato",
    requiredDate: "Il campo è obbligatorio!",
    urlNotFound: "Nessun file!",
    urlNotFoundDesc: "Questo certificato non contiene un file allegato",
    avisoFactura: "Filtri necessari!",
    avisoFacturaDesc: "È necessario passare un rappresentante o un cliente.",
    notFoundReport: "Rapporto non trovato!",
    notFoundReportDesc: "Non è stato trovato il rapporto con i dati forniti",
    estadoVentaNotFound: "Rapporto non trovato!",
    estadoVentaNotFoundDesc: "Non è stato trovato il rapporto con i dati forniti",
    vencimientoNotFound: "Nessun rapporto trovato!",
    vencimientoNotFoundDesc: "Non è stato trovato il rapporto con i dati forniti",
    vencimientoNotFoundError: "Errore di connessione!",
    vencimientoNotFoundErrorDesc: "Errore di connessione, riprovare più tardi.",
    errorDefault: "Errore di connessione!",
    errorDefaultDesc: "Errore nella connessione del rapporto",
    errorNumRecogidas: "Errore nel download!",
    errorNumRecogidasDesc: "Non è possibile scaricare più di 1100 risultati",
    errorInsertUser: "Errore nell'aggiornamento utente!",
    errorInsertUserDesc: "Verifica che tutto sia corretto!",
    errorInsertUser500: "Impossibile aggiornare correttamente l'utente",
    errorDeleteUser: "Errore nell'eliminazione utente!",
    insercionRoles: "Modifiche effettuate!",
    insercionRolesDesc: "Date inserite correttamente",
    insercionRolesDescAct: "Date aggiornate correttamente",
    errorRoles: "Errore trovato!",
    errorRolesDesc: "Errore nella gestione delle date",
    notLoginDefault: "Errore di login",
    notLoginDefaultDesc: "Errore nel tentativo di login",
    notFacturaFound: "Nessuna fattura",
    notFacturaFoundDesc: "Non sono state trovate fatture",
    notAlbaranFound: "Nessuna bolla",
    notAlbaranFoundDesc: "Nessun rapporto trovato per questa bolla",
    notAlbaranFoundInPedDesc: "Nessuna bolla associata a questo ordine",
    notDataLoginFound: "Errore nel recupero dati",
    notDataLoginFoundDesc: "Impossibile recuperare i dati",
    onePresupuesto: "Seleziona un solo preventivo",
    notStatusCorrect: "Non è possibile modificare un preventivo già accettato.",
    filtersAlert: "Filtri necessari",
    filtersClientSuc: "È necessario passare un cliente con la sua filiale.",
    filtersClient: "È necessario passare un cliente.",
    filtersSuc: "È necessario passare una filiale.",
    delPres: "Errore nell'eliminazione del preventivo!",
    delPresDesc: "Il preventivo è stato accettato e non può più essere eliminato.",
    tipoCompVen: "Tipo di ordine",
    noData: "Nessun risultato",
    searchPanel: "Cerca",
    compras: "Acquisti",
    ventas: "Vendite",
    transitos: "Transiti",
    beneficio: "Profitto",
    proveedor: "Fornitore",
    sucProveedor: "Filiale fornitore",
    matricula: "Targa",
    precioMedio: "Prezzo medio",
    transporte: "Trasporto",
    almacen: "Magazzino",
    albaranTte: "Bolla TTE",
    costeTte: "Costo TTE",
    importeTte: "Importo TTE",
    transportista: "Trasportatore",
    startsWidth: "Inizia con",
    equals: "Uguale",
    between: "Tra",
    contains: "Contiene",
    endsWith: "Termina con",
    greaterThan: "Maggiore di",
    lessThan: "Minore di",
    lessThanOrEqual: "Minore o uguale a",
    notContains: "Non contiene",
    notEqual: "Diverso",
    greaterThanOrEqual: "Maggiore o uguale a",
    reset: "Pulisci",
    filterMonth: "Filtra per mese attuale",
    filtroAvzClte: "Filtro avanzato cliente",
    filtroAvzPed: "Filtro avanzato ordine",
    descargaExcel: "Scarica Excel",
    alertsCancel: "Annulla",
    alertsAceptar: "Accetta",
    nuevaVersion: "È stata rilevata una nuova versione. Vuoi ricaricare la pagina?",
    selecBultoAlb: "Seleziona un collo dalla bolla",
    descagarExcel: "Scaricare Excel",
    consultaDocEstadoPed: "Consultare i documenti nello stato degli ordini",
    archivoEnviadoEmail: "Il file verra inviato a {email}"
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/config/i18n-config.js